webpackJsonp([114276838955818,60335399758886],{

/***/ 64:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./baseline-mark.svg": 274,
		"./pixelmoxie-logo.svg": 275,
		"./shape-arrow-back-large.svg": 177,
		"./shape-arrow-forward-large.svg": 178,
		"./shape-button-arrow.svg": 41,
		"./shape-check-16px.svg": 179,
		"./shape-eye.svg": 180,
		"./shape-hero-curved-bottom.svg": 181,
		"./shape-newsletter-curved-top.svg": 276,
		"./shape-twitter-logo.svg": 695
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 709;


/***/ }),

/***/ 66:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(64),
	    deburr = __webpack_require__(73),
	    words = __webpack_require__(77);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(66);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(68),
	    toString = __webpack_require__(32);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('kebabCase', __webpack_require__(76), __webpack_require__(29));
	
	func.placeholder = __webpack_require__(30);
	module.exports = func;


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(67);
	
	/**
	 * Converts `string` to
	 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the kebab cased string.
	 * @example
	 *
	 * _.kebabCase('Foo Bar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('fooBar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('__FOO_BAR__');
	 * // => 'foo-bar'
	 */
	var kebabCase = createCompounder(function(result, word, index) {
	  return result + (index ? '-' : '') + word.toLowerCase();
	});
	
	module.exports = kebabCase;


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(65),
	    hasUnicodeWord = __webpack_require__(70),
	    toString = __webpack_require__(32),
	    unicodeWords = __webpack_require__(72);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	var ENTITIES = [['Aacute', [193]], ['aacute', [225]], ['Abreve', [258]], ['abreve', [259]], ['ac', [8766]], ['acd', [8767]], ['acE', [8766, 819]], ['Acirc', [194]], ['acirc', [226]], ['acute', [180]], ['Acy', [1040]], ['acy', [1072]], ['AElig', [198]], ['aelig', [230]], ['af', [8289]], ['Afr', [120068]], ['afr', [120094]], ['Agrave', [192]], ['agrave', [224]], ['alefsym', [8501]], ['aleph', [8501]], ['Alpha', [913]], ['alpha', [945]], ['Amacr', [256]], ['amacr', [257]], ['amalg', [10815]], ['amp', [38]], ['AMP', [38]], ['andand', [10837]], ['And', [10835]], ['and', [8743]], ['andd', [10844]], ['andslope', [10840]], ['andv', [10842]], ['ang', [8736]], ['ange', [10660]], ['angle', [8736]], ['angmsdaa', [10664]], ['angmsdab', [10665]], ['angmsdac', [10666]], ['angmsdad', [10667]], ['angmsdae', [10668]], ['angmsdaf', [10669]], ['angmsdag', [10670]], ['angmsdah', [10671]], ['angmsd', [8737]], ['angrt', [8735]], ['angrtvb', [8894]], ['angrtvbd', [10653]], ['angsph', [8738]], ['angst', [197]], ['angzarr', [9084]], ['Aogon', [260]], ['aogon', [261]], ['Aopf', [120120]], ['aopf', [120146]], ['apacir', [10863]], ['ap', [8776]], ['apE', [10864]], ['ape', [8778]], ['apid', [8779]], ['apos', [39]], ['ApplyFunction', [8289]], ['approx', [8776]], ['approxeq', [8778]], ['Aring', [197]], ['aring', [229]], ['Ascr', [119964]], ['ascr', [119990]], ['Assign', [8788]], ['ast', [42]], ['asymp', [8776]], ['asympeq', [8781]], ['Atilde', [195]], ['atilde', [227]], ['Auml', [196]], ['auml', [228]], ['awconint', [8755]], ['awint', [10769]], ['backcong', [8780]], ['backepsilon', [1014]], ['backprime', [8245]], ['backsim', [8765]], ['backsimeq', [8909]], ['Backslash', [8726]], ['Barv', [10983]], ['barvee', [8893]], ['barwed', [8965]], ['Barwed', [8966]], ['barwedge', [8965]], ['bbrk', [9141]], ['bbrktbrk', [9142]], ['bcong', [8780]], ['Bcy', [1041]], ['bcy', [1073]], ['bdquo', [8222]], ['becaus', [8757]], ['because', [8757]], ['Because', [8757]], ['bemptyv', [10672]], ['bepsi', [1014]], ['bernou', [8492]], ['Bernoullis', [8492]], ['Beta', [914]], ['beta', [946]], ['beth', [8502]], ['between', [8812]], ['Bfr', [120069]], ['bfr', [120095]], ['bigcap', [8898]], ['bigcirc', [9711]], ['bigcup', [8899]], ['bigodot', [10752]], ['bigoplus', [10753]], ['bigotimes', [10754]], ['bigsqcup', [10758]], ['bigstar', [9733]], ['bigtriangledown', [9661]], ['bigtriangleup', [9651]], ['biguplus', [10756]], ['bigvee', [8897]], ['bigwedge', [8896]], ['bkarow', [10509]], ['blacklozenge', [10731]], ['blacksquare', [9642]], ['blacktriangle', [9652]], ['blacktriangledown', [9662]], ['blacktriangleleft', [9666]], ['blacktriangleright', [9656]], ['blank', [9251]], ['blk12', [9618]], ['blk14', [9617]], ['blk34', [9619]], ['block', [9608]], ['bne', [61, 8421]], ['bnequiv', [8801, 8421]], ['bNot', [10989]], ['bnot', [8976]], ['Bopf', [120121]], ['bopf', [120147]], ['bot', [8869]], ['bottom', [8869]], ['bowtie', [8904]], ['boxbox', [10697]], ['boxdl', [9488]], ['boxdL', [9557]], ['boxDl', [9558]], ['boxDL', [9559]], ['boxdr', [9484]], ['boxdR', [9554]], ['boxDr', [9555]], ['boxDR', [9556]], ['boxh', [9472]], ['boxH', [9552]], ['boxhd', [9516]], ['boxHd', [9572]], ['boxhD', [9573]], ['boxHD', [9574]], ['boxhu', [9524]], ['boxHu', [9575]], ['boxhU', [9576]], ['boxHU', [9577]], ['boxminus', [8863]], ['boxplus', [8862]], ['boxtimes', [8864]], ['boxul', [9496]], ['boxuL', [9563]], ['boxUl', [9564]], ['boxUL', [9565]], ['boxur', [9492]], ['boxuR', [9560]], ['boxUr', [9561]], ['boxUR', [9562]], ['boxv', [9474]], ['boxV', [9553]], ['boxvh', [9532]], ['boxvH', [9578]], ['boxVh', [9579]], ['boxVH', [9580]], ['boxvl', [9508]], ['boxvL', [9569]], ['boxVl', [9570]], ['boxVL', [9571]], ['boxvr', [9500]], ['boxvR', [9566]], ['boxVr', [9567]], ['boxVR', [9568]], ['bprime', [8245]], ['breve', [728]], ['Breve', [728]], ['brvbar', [166]], ['bscr', [119991]], ['Bscr', [8492]], ['bsemi', [8271]], ['bsim', [8765]], ['bsime', [8909]], ['bsolb', [10693]], ['bsol', [92]], ['bsolhsub', [10184]], ['bull', [8226]], ['bullet', [8226]], ['bump', [8782]], ['bumpE', [10926]], ['bumpe', [8783]], ['Bumpeq', [8782]], ['bumpeq', [8783]], ['Cacute', [262]], ['cacute', [263]], ['capand', [10820]], ['capbrcup', [10825]], ['capcap', [10827]], ['cap', [8745]], ['Cap', [8914]], ['capcup', [10823]], ['capdot', [10816]], ['CapitalDifferentialD', [8517]], ['caps', [8745, 65024]], ['caret', [8257]], ['caron', [711]], ['Cayleys', [8493]], ['ccaps', [10829]], ['Ccaron', [268]], ['ccaron', [269]], ['Ccedil', [199]], ['ccedil', [231]], ['Ccirc', [264]], ['ccirc', [265]], ['Cconint', [8752]], ['ccups', [10828]], ['ccupssm', [10832]], ['Cdot', [266]], ['cdot', [267]], ['cedil', [184]], ['Cedilla', [184]], ['cemptyv', [10674]], ['cent', [162]], ['centerdot', [183]], ['CenterDot', [183]], ['cfr', [120096]], ['Cfr', [8493]], ['CHcy', [1063]], ['chcy', [1095]], ['check', [10003]], ['checkmark', [10003]], ['Chi', [935]], ['chi', [967]], ['circ', [710]], ['circeq', [8791]], ['circlearrowleft', [8634]], ['circlearrowright', [8635]], ['circledast', [8859]], ['circledcirc', [8858]], ['circleddash', [8861]], ['CircleDot', [8857]], ['circledR', [174]], ['circledS', [9416]], ['CircleMinus', [8854]], ['CirclePlus', [8853]], ['CircleTimes', [8855]], ['cir', [9675]], ['cirE', [10691]], ['cire', [8791]], ['cirfnint', [10768]], ['cirmid', [10991]], ['cirscir', [10690]], ['ClockwiseContourIntegral', [8754]], ['clubs', [9827]], ['clubsuit', [9827]], ['colon', [58]], ['Colon', [8759]], ['Colone', [10868]], ['colone', [8788]], ['coloneq', [8788]], ['comma', [44]], ['commat', [64]], ['comp', [8705]], ['compfn', [8728]], ['complement', [8705]], ['complexes', [8450]], ['cong', [8773]], ['congdot', [10861]], ['Congruent', [8801]], ['conint', [8750]], ['Conint', [8751]], ['ContourIntegral', [8750]], ['copf', [120148]], ['Copf', [8450]], ['coprod', [8720]], ['Coproduct', [8720]], ['copy', [169]], ['COPY', [169]], ['copysr', [8471]], ['CounterClockwiseContourIntegral', [8755]], ['crarr', [8629]], ['cross', [10007]], ['Cross', [10799]], ['Cscr', [119966]], ['cscr', [119992]], ['csub', [10959]], ['csube', [10961]], ['csup', [10960]], ['csupe', [10962]], ['ctdot', [8943]], ['cudarrl', [10552]], ['cudarrr', [10549]], ['cuepr', [8926]], ['cuesc', [8927]], ['cularr', [8630]], ['cularrp', [10557]], ['cupbrcap', [10824]], ['cupcap', [10822]], ['CupCap', [8781]], ['cup', [8746]], ['Cup', [8915]], ['cupcup', [10826]], ['cupdot', [8845]], ['cupor', [10821]], ['cups', [8746, 65024]], ['curarr', [8631]], ['curarrm', [10556]], ['curlyeqprec', [8926]], ['curlyeqsucc', [8927]], ['curlyvee', [8910]], ['curlywedge', [8911]], ['curren', [164]], ['curvearrowleft', [8630]], ['curvearrowright', [8631]], ['cuvee', [8910]], ['cuwed', [8911]], ['cwconint', [8754]], ['cwint', [8753]], ['cylcty', [9005]], ['dagger', [8224]], ['Dagger', [8225]], ['daleth', [8504]], ['darr', [8595]], ['Darr', [8609]], ['dArr', [8659]], ['dash', [8208]], ['Dashv', [10980]], ['dashv', [8867]], ['dbkarow', [10511]], ['dblac', [733]], ['Dcaron', [270]], ['dcaron', [271]], ['Dcy', [1044]], ['dcy', [1076]], ['ddagger', [8225]], ['ddarr', [8650]], ['DD', [8517]], ['dd', [8518]], ['DDotrahd', [10513]], ['ddotseq', [10871]], ['deg', [176]], ['Del', [8711]], ['Delta', [916]], ['delta', [948]], ['demptyv', [10673]], ['dfisht', [10623]], ['Dfr', [120071]], ['dfr', [120097]], ['dHar', [10597]], ['dharl', [8643]], ['dharr', [8642]], ['DiacriticalAcute', [180]], ['DiacriticalDot', [729]], ['DiacriticalDoubleAcute', [733]], ['DiacriticalGrave', [96]], ['DiacriticalTilde', [732]], ['diam', [8900]], ['diamond', [8900]], ['Diamond', [8900]], ['diamondsuit', [9830]], ['diams', [9830]], ['die', [168]], ['DifferentialD', [8518]], ['digamma', [989]], ['disin', [8946]], ['div', [247]], ['divide', [247]], ['divideontimes', [8903]], ['divonx', [8903]], ['DJcy', [1026]], ['djcy', [1106]], ['dlcorn', [8990]], ['dlcrop', [8973]], ['dollar', [36]], ['Dopf', [120123]], ['dopf', [120149]], ['Dot', [168]], ['dot', [729]], ['DotDot', [8412]], ['doteq', [8784]], ['doteqdot', [8785]], ['DotEqual', [8784]], ['dotminus', [8760]], ['dotplus', [8724]], ['dotsquare', [8865]], ['doublebarwedge', [8966]], ['DoubleContourIntegral', [8751]], ['DoubleDot', [168]], ['DoubleDownArrow', [8659]], ['DoubleLeftArrow', [8656]], ['DoubleLeftRightArrow', [8660]], ['DoubleLeftTee', [10980]], ['DoubleLongLeftArrow', [10232]], ['DoubleLongLeftRightArrow', [10234]], ['DoubleLongRightArrow', [10233]], ['DoubleRightArrow', [8658]], ['DoubleRightTee', [8872]], ['DoubleUpArrow', [8657]], ['DoubleUpDownArrow', [8661]], ['DoubleVerticalBar', [8741]], ['DownArrowBar', [10515]], ['downarrow', [8595]], ['DownArrow', [8595]], ['Downarrow', [8659]], ['DownArrowUpArrow', [8693]], ['DownBreve', [785]], ['downdownarrows', [8650]], ['downharpoonleft', [8643]], ['downharpoonright', [8642]], ['DownLeftRightVector', [10576]], ['DownLeftTeeVector', [10590]], ['DownLeftVectorBar', [10582]], ['DownLeftVector', [8637]], ['DownRightTeeVector', [10591]], ['DownRightVectorBar', [10583]], ['DownRightVector', [8641]], ['DownTeeArrow', [8615]], ['DownTee', [8868]], ['drbkarow', [10512]], ['drcorn', [8991]], ['drcrop', [8972]], ['Dscr', [119967]], ['dscr', [119993]], ['DScy', [1029]], ['dscy', [1109]], ['dsol', [10742]], ['Dstrok', [272]], ['dstrok', [273]], ['dtdot', [8945]], ['dtri', [9663]], ['dtrif', [9662]], ['duarr', [8693]], ['duhar', [10607]], ['dwangle', [10662]], ['DZcy', [1039]], ['dzcy', [1119]], ['dzigrarr', [10239]], ['Eacute', [201]], ['eacute', [233]], ['easter', [10862]], ['Ecaron', [282]], ['ecaron', [283]], ['Ecirc', [202]], ['ecirc', [234]], ['ecir', [8790]], ['ecolon', [8789]], ['Ecy', [1069]], ['ecy', [1101]], ['eDDot', [10871]], ['Edot', [278]], ['edot', [279]], ['eDot', [8785]], ['ee', [8519]], ['efDot', [8786]], ['Efr', [120072]], ['efr', [120098]], ['eg', [10906]], ['Egrave', [200]], ['egrave', [232]], ['egs', [10902]], ['egsdot', [10904]], ['el', [10905]], ['Element', [8712]], ['elinters', [9191]], ['ell', [8467]], ['els', [10901]], ['elsdot', [10903]], ['Emacr', [274]], ['emacr', [275]], ['empty', [8709]], ['emptyset', [8709]], ['EmptySmallSquare', [9723]], ['emptyv', [8709]], ['EmptyVerySmallSquare', [9643]], ['emsp13', [8196]], ['emsp14', [8197]], ['emsp', [8195]], ['ENG', [330]], ['eng', [331]], ['ensp', [8194]], ['Eogon', [280]], ['eogon', [281]], ['Eopf', [120124]], ['eopf', [120150]], ['epar', [8917]], ['eparsl', [10723]], ['eplus', [10865]], ['epsi', [949]], ['Epsilon', [917]], ['epsilon', [949]], ['epsiv', [1013]], ['eqcirc', [8790]], ['eqcolon', [8789]], ['eqsim', [8770]], ['eqslantgtr', [10902]], ['eqslantless', [10901]], ['Equal', [10869]], ['equals', [61]], ['EqualTilde', [8770]], ['equest', [8799]], ['Equilibrium', [8652]], ['equiv', [8801]], ['equivDD', [10872]], ['eqvparsl', [10725]], ['erarr', [10609]], ['erDot', [8787]], ['escr', [8495]], ['Escr', [8496]], ['esdot', [8784]], ['Esim', [10867]], ['esim', [8770]], ['Eta', [919]], ['eta', [951]], ['ETH', [208]], ['eth', [240]], ['Euml', [203]], ['euml', [235]], ['euro', [8364]], ['excl', [33]], ['exist', [8707]], ['Exists', [8707]], ['expectation', [8496]], ['exponentiale', [8519]], ['ExponentialE', [8519]], ['fallingdotseq', [8786]], ['Fcy', [1060]], ['fcy', [1092]], ['female', [9792]], ['ffilig', [64259]], ['fflig', [64256]], ['ffllig', [64260]], ['Ffr', [120073]], ['ffr', [120099]], ['filig', [64257]], ['FilledSmallSquare', [9724]], ['FilledVerySmallSquare', [9642]], ['fjlig', [102, 106]], ['flat', [9837]], ['fllig', [64258]], ['fltns', [9649]], ['fnof', [402]], ['Fopf', [120125]], ['fopf', [120151]], ['forall', [8704]], ['ForAll', [8704]], ['fork', [8916]], ['forkv', [10969]], ['Fouriertrf', [8497]], ['fpartint', [10765]], ['frac12', [189]], ['frac13', [8531]], ['frac14', [188]], ['frac15', [8533]], ['frac16', [8537]], ['frac18', [8539]], ['frac23', [8532]], ['frac25', [8534]], ['frac34', [190]], ['frac35', [8535]], ['frac38', [8540]], ['frac45', [8536]], ['frac56', [8538]], ['frac58', [8541]], ['frac78', [8542]], ['frasl', [8260]], ['frown', [8994]], ['fscr', [119995]], ['Fscr', [8497]], ['gacute', [501]], ['Gamma', [915]], ['gamma', [947]], ['Gammad', [988]], ['gammad', [989]], ['gap', [10886]], ['Gbreve', [286]], ['gbreve', [287]], ['Gcedil', [290]], ['Gcirc', [284]], ['gcirc', [285]], ['Gcy', [1043]], ['gcy', [1075]], ['Gdot', [288]], ['gdot', [289]], ['ge', [8805]], ['gE', [8807]], ['gEl', [10892]], ['gel', [8923]], ['geq', [8805]], ['geqq', [8807]], ['geqslant', [10878]], ['gescc', [10921]], ['ges', [10878]], ['gesdot', [10880]], ['gesdoto', [10882]], ['gesdotol', [10884]], ['gesl', [8923, 65024]], ['gesles', [10900]], ['Gfr', [120074]], ['gfr', [120100]], ['gg', [8811]], ['Gg', [8921]], ['ggg', [8921]], ['gimel', [8503]], ['GJcy', [1027]], ['gjcy', [1107]], ['gla', [10917]], ['gl', [8823]], ['glE', [10898]], ['glj', [10916]], ['gnap', [10890]], ['gnapprox', [10890]], ['gne', [10888]], ['gnE', [8809]], ['gneq', [10888]], ['gneqq', [8809]], ['gnsim', [8935]], ['Gopf', [120126]], ['gopf', [120152]], ['grave', [96]], ['GreaterEqual', [8805]], ['GreaterEqualLess', [8923]], ['GreaterFullEqual', [8807]], ['GreaterGreater', [10914]], ['GreaterLess', [8823]], ['GreaterSlantEqual', [10878]], ['GreaterTilde', [8819]], ['Gscr', [119970]], ['gscr', [8458]], ['gsim', [8819]], ['gsime', [10894]], ['gsiml', [10896]], ['gtcc', [10919]], ['gtcir', [10874]], ['gt', [62]], ['GT', [62]], ['Gt', [8811]], ['gtdot', [8919]], ['gtlPar', [10645]], ['gtquest', [10876]], ['gtrapprox', [10886]], ['gtrarr', [10616]], ['gtrdot', [8919]], ['gtreqless', [8923]], ['gtreqqless', [10892]], ['gtrless', [8823]], ['gtrsim', [8819]], ['gvertneqq', [8809, 65024]], ['gvnE', [8809, 65024]], ['Hacek', [711]], ['hairsp', [8202]], ['half', [189]], ['hamilt', [8459]], ['HARDcy', [1066]], ['hardcy', [1098]], ['harrcir', [10568]], ['harr', [8596]], ['hArr', [8660]], ['harrw', [8621]], ['Hat', [94]], ['hbar', [8463]], ['Hcirc', [292]], ['hcirc', [293]], ['hearts', [9829]], ['heartsuit', [9829]], ['hellip', [8230]], ['hercon', [8889]], ['hfr', [120101]], ['Hfr', [8460]], ['HilbertSpace', [8459]], ['hksearow', [10533]], ['hkswarow', [10534]], ['hoarr', [8703]], ['homtht', [8763]], ['hookleftarrow', [8617]], ['hookrightarrow', [8618]], ['hopf', [120153]], ['Hopf', [8461]], ['horbar', [8213]], ['HorizontalLine', [9472]], ['hscr', [119997]], ['Hscr', [8459]], ['hslash', [8463]], ['Hstrok', [294]], ['hstrok', [295]], ['HumpDownHump', [8782]], ['HumpEqual', [8783]], ['hybull', [8259]], ['hyphen', [8208]], ['Iacute', [205]], ['iacute', [237]], ['ic', [8291]], ['Icirc', [206]], ['icirc', [238]], ['Icy', [1048]], ['icy', [1080]], ['Idot', [304]], ['IEcy', [1045]], ['iecy', [1077]], ['iexcl', [161]], ['iff', [8660]], ['ifr', [120102]], ['Ifr', [8465]], ['Igrave', [204]], ['igrave', [236]], ['ii', [8520]], ['iiiint', [10764]], ['iiint', [8749]], ['iinfin', [10716]], ['iiota', [8489]], ['IJlig', [306]], ['ijlig', [307]], ['Imacr', [298]], ['imacr', [299]], ['image', [8465]], ['ImaginaryI', [8520]], ['imagline', [8464]], ['imagpart', [8465]], ['imath', [305]], ['Im', [8465]], ['imof', [8887]], ['imped', [437]], ['Implies', [8658]], ['incare', [8453]], ['in', [8712]], ['infin', [8734]], ['infintie', [10717]], ['inodot', [305]], ['intcal', [8890]], ['int', [8747]], ['Int', [8748]], ['integers', [8484]], ['Integral', [8747]], ['intercal', [8890]], ['Intersection', [8898]], ['intlarhk', [10775]], ['intprod', [10812]], ['InvisibleComma', [8291]], ['InvisibleTimes', [8290]], ['IOcy', [1025]], ['iocy', [1105]], ['Iogon', [302]], ['iogon', [303]], ['Iopf', [120128]], ['iopf', [120154]], ['Iota', [921]], ['iota', [953]], ['iprod', [10812]], ['iquest', [191]], ['iscr', [119998]], ['Iscr', [8464]], ['isin', [8712]], ['isindot', [8949]], ['isinE', [8953]], ['isins', [8948]], ['isinsv', [8947]], ['isinv', [8712]], ['it', [8290]], ['Itilde', [296]], ['itilde', [297]], ['Iukcy', [1030]], ['iukcy', [1110]], ['Iuml', [207]], ['iuml', [239]], ['Jcirc', [308]], ['jcirc', [309]], ['Jcy', [1049]], ['jcy', [1081]], ['Jfr', [120077]], ['jfr', [120103]], ['jmath', [567]], ['Jopf', [120129]], ['jopf', [120155]], ['Jscr', [119973]], ['jscr', [119999]], ['Jsercy', [1032]], ['jsercy', [1112]], ['Jukcy', [1028]], ['jukcy', [1108]], ['Kappa', [922]], ['kappa', [954]], ['kappav', [1008]], ['Kcedil', [310]], ['kcedil', [311]], ['Kcy', [1050]], ['kcy', [1082]], ['Kfr', [120078]], ['kfr', [120104]], ['kgreen', [312]], ['KHcy', [1061]], ['khcy', [1093]], ['KJcy', [1036]], ['kjcy', [1116]], ['Kopf', [120130]], ['kopf', [120156]], ['Kscr', [119974]], ['kscr', [120000]], ['lAarr', [8666]], ['Lacute', [313]], ['lacute', [314]], ['laemptyv', [10676]], ['lagran', [8466]], ['Lambda', [923]], ['lambda', [955]], ['lang', [10216]], ['Lang', [10218]], ['langd', [10641]], ['langle', [10216]], ['lap', [10885]], ['Laplacetrf', [8466]], ['laquo', [171]], ['larrb', [8676]], ['larrbfs', [10527]], ['larr', [8592]], ['Larr', [8606]], ['lArr', [8656]], ['larrfs', [10525]], ['larrhk', [8617]], ['larrlp', [8619]], ['larrpl', [10553]], ['larrsim', [10611]], ['larrtl', [8610]], ['latail', [10521]], ['lAtail', [10523]], ['lat', [10923]], ['late', [10925]], ['lates', [10925, 65024]], ['lbarr', [10508]], ['lBarr', [10510]], ['lbbrk', [10098]], ['lbrace', [123]], ['lbrack', [91]], ['lbrke', [10635]], ['lbrksld', [10639]], ['lbrkslu', [10637]], ['Lcaron', [317]], ['lcaron', [318]], ['Lcedil', [315]], ['lcedil', [316]], ['lceil', [8968]], ['lcub', [123]], ['Lcy', [1051]], ['lcy', [1083]], ['ldca', [10550]], ['ldquo', [8220]], ['ldquor', [8222]], ['ldrdhar', [10599]], ['ldrushar', [10571]], ['ldsh', [8626]], ['le', [8804]], ['lE', [8806]], ['LeftAngleBracket', [10216]], ['LeftArrowBar', [8676]], ['leftarrow', [8592]], ['LeftArrow', [8592]], ['Leftarrow', [8656]], ['LeftArrowRightArrow', [8646]], ['leftarrowtail', [8610]], ['LeftCeiling', [8968]], ['LeftDoubleBracket', [10214]], ['LeftDownTeeVector', [10593]], ['LeftDownVectorBar', [10585]], ['LeftDownVector', [8643]], ['LeftFloor', [8970]], ['leftharpoondown', [8637]], ['leftharpoonup', [8636]], ['leftleftarrows', [8647]], ['leftrightarrow', [8596]], ['LeftRightArrow', [8596]], ['Leftrightarrow', [8660]], ['leftrightarrows', [8646]], ['leftrightharpoons', [8651]], ['leftrightsquigarrow', [8621]], ['LeftRightVector', [10574]], ['LeftTeeArrow', [8612]], ['LeftTee', [8867]], ['LeftTeeVector', [10586]], ['leftthreetimes', [8907]], ['LeftTriangleBar', [10703]], ['LeftTriangle', [8882]], ['LeftTriangleEqual', [8884]], ['LeftUpDownVector', [10577]], ['LeftUpTeeVector', [10592]], ['LeftUpVectorBar', [10584]], ['LeftUpVector', [8639]], ['LeftVectorBar', [10578]], ['LeftVector', [8636]], ['lEg', [10891]], ['leg', [8922]], ['leq', [8804]], ['leqq', [8806]], ['leqslant', [10877]], ['lescc', [10920]], ['les', [10877]], ['lesdot', [10879]], ['lesdoto', [10881]], ['lesdotor', [10883]], ['lesg', [8922, 65024]], ['lesges', [10899]], ['lessapprox', [10885]], ['lessdot', [8918]], ['lesseqgtr', [8922]], ['lesseqqgtr', [10891]], ['LessEqualGreater', [8922]], ['LessFullEqual', [8806]], ['LessGreater', [8822]], ['lessgtr', [8822]], ['LessLess', [10913]], ['lesssim', [8818]], ['LessSlantEqual', [10877]], ['LessTilde', [8818]], ['lfisht', [10620]], ['lfloor', [8970]], ['Lfr', [120079]], ['lfr', [120105]], ['lg', [8822]], ['lgE', [10897]], ['lHar', [10594]], ['lhard', [8637]], ['lharu', [8636]], ['lharul', [10602]], ['lhblk', [9604]], ['LJcy', [1033]], ['ljcy', [1113]], ['llarr', [8647]], ['ll', [8810]], ['Ll', [8920]], ['llcorner', [8990]], ['Lleftarrow', [8666]], ['llhard', [10603]], ['lltri', [9722]], ['Lmidot', [319]], ['lmidot', [320]], ['lmoustache', [9136]], ['lmoust', [9136]], ['lnap', [10889]], ['lnapprox', [10889]], ['lne', [10887]], ['lnE', [8808]], ['lneq', [10887]], ['lneqq', [8808]], ['lnsim', [8934]], ['loang', [10220]], ['loarr', [8701]], ['lobrk', [10214]], ['longleftarrow', [10229]], ['LongLeftArrow', [10229]], ['Longleftarrow', [10232]], ['longleftrightarrow', [10231]], ['LongLeftRightArrow', [10231]], ['Longleftrightarrow', [10234]], ['longmapsto', [10236]], ['longrightarrow', [10230]], ['LongRightArrow', [10230]], ['Longrightarrow', [10233]], ['looparrowleft', [8619]], ['looparrowright', [8620]], ['lopar', [10629]], ['Lopf', [120131]], ['lopf', [120157]], ['loplus', [10797]], ['lotimes', [10804]], ['lowast', [8727]], ['lowbar', [95]], ['LowerLeftArrow', [8601]], ['LowerRightArrow', [8600]], ['loz', [9674]], ['lozenge', [9674]], ['lozf', [10731]], ['lpar', [40]], ['lparlt', [10643]], ['lrarr', [8646]], ['lrcorner', [8991]], ['lrhar', [8651]], ['lrhard', [10605]], ['lrm', [8206]], ['lrtri', [8895]], ['lsaquo', [8249]], ['lscr', [120001]], ['Lscr', [8466]], ['lsh', [8624]], ['Lsh', [8624]], ['lsim', [8818]], ['lsime', [10893]], ['lsimg', [10895]], ['lsqb', [91]], ['lsquo', [8216]], ['lsquor', [8218]], ['Lstrok', [321]], ['lstrok', [322]], ['ltcc', [10918]], ['ltcir', [10873]], ['lt', [60]], ['LT', [60]], ['Lt', [8810]], ['ltdot', [8918]], ['lthree', [8907]], ['ltimes', [8905]], ['ltlarr', [10614]], ['ltquest', [10875]], ['ltri', [9667]], ['ltrie', [8884]], ['ltrif', [9666]], ['ltrPar', [10646]], ['lurdshar', [10570]], ['luruhar', [10598]], ['lvertneqq', [8808, 65024]], ['lvnE', [8808, 65024]], ['macr', [175]], ['male', [9794]], ['malt', [10016]], ['maltese', [10016]], ['Map', [10501]], ['map', [8614]], ['mapsto', [8614]], ['mapstodown', [8615]], ['mapstoleft', [8612]], ['mapstoup', [8613]], ['marker', [9646]], ['mcomma', [10793]], ['Mcy', [1052]], ['mcy', [1084]], ['mdash', [8212]], ['mDDot', [8762]], ['measuredangle', [8737]], ['MediumSpace', [8287]], ['Mellintrf', [8499]], ['Mfr', [120080]], ['mfr', [120106]], ['mho', [8487]], ['micro', [181]], ['midast', [42]], ['midcir', [10992]], ['mid', [8739]], ['middot', [183]], ['minusb', [8863]], ['minus', [8722]], ['minusd', [8760]], ['minusdu', [10794]], ['MinusPlus', [8723]], ['mlcp', [10971]], ['mldr', [8230]], ['mnplus', [8723]], ['models', [8871]], ['Mopf', [120132]], ['mopf', [120158]], ['mp', [8723]], ['mscr', [120002]], ['Mscr', [8499]], ['mstpos', [8766]], ['Mu', [924]], ['mu', [956]], ['multimap', [8888]], ['mumap', [8888]], ['nabla', [8711]], ['Nacute', [323]], ['nacute', [324]], ['nang', [8736, 8402]], ['nap', [8777]], ['napE', [10864, 824]], ['napid', [8779, 824]], ['napos', [329]], ['napprox', [8777]], ['natural', [9838]], ['naturals', [8469]], ['natur', [9838]], ['nbsp', [160]], ['nbump', [8782, 824]], ['nbumpe', [8783, 824]], ['ncap', [10819]], ['Ncaron', [327]], ['ncaron', [328]], ['Ncedil', [325]], ['ncedil', [326]], ['ncong', [8775]], ['ncongdot', [10861, 824]], ['ncup', [10818]], ['Ncy', [1053]], ['ncy', [1085]], ['ndash', [8211]], ['nearhk', [10532]], ['nearr', [8599]], ['neArr', [8663]], ['nearrow', [8599]], ['ne', [8800]], ['nedot', [8784, 824]], ['NegativeMediumSpace', [8203]], ['NegativeThickSpace', [8203]], ['NegativeThinSpace', [8203]], ['NegativeVeryThinSpace', [8203]], ['nequiv', [8802]], ['nesear', [10536]], ['nesim', [8770, 824]], ['NestedGreaterGreater', [8811]], ['NestedLessLess', [8810]], ['nexist', [8708]], ['nexists', [8708]], ['Nfr', [120081]], ['nfr', [120107]], ['ngE', [8807, 824]], ['nge', [8817]], ['ngeq', [8817]], ['ngeqq', [8807, 824]], ['ngeqslant', [10878, 824]], ['nges', [10878, 824]], ['nGg', [8921, 824]], ['ngsim', [8821]], ['nGt', [8811, 8402]], ['ngt', [8815]], ['ngtr', [8815]], ['nGtv', [8811, 824]], ['nharr', [8622]], ['nhArr', [8654]], ['nhpar', [10994]], ['ni', [8715]], ['nis', [8956]], ['nisd', [8954]], ['niv', [8715]], ['NJcy', [1034]], ['njcy', [1114]], ['nlarr', [8602]], ['nlArr', [8653]], ['nldr', [8229]], ['nlE', [8806, 824]], ['nle', [8816]], ['nleftarrow', [8602]], ['nLeftarrow', [8653]], ['nleftrightarrow', [8622]], ['nLeftrightarrow', [8654]], ['nleq', [8816]], ['nleqq', [8806, 824]], ['nleqslant', [10877, 824]], ['nles', [10877, 824]], ['nless', [8814]], ['nLl', [8920, 824]], ['nlsim', [8820]], ['nLt', [8810, 8402]], ['nlt', [8814]], ['nltri', [8938]], ['nltrie', [8940]], ['nLtv', [8810, 824]], ['nmid', [8740]], ['NoBreak', [8288]], ['NonBreakingSpace', [160]], ['nopf', [120159]], ['Nopf', [8469]], ['Not', [10988]], ['not', [172]], ['NotCongruent', [8802]], ['NotCupCap', [8813]], ['NotDoubleVerticalBar', [8742]], ['NotElement', [8713]], ['NotEqual', [8800]], ['NotEqualTilde', [8770, 824]], ['NotExists', [8708]], ['NotGreater', [8815]], ['NotGreaterEqual', [8817]], ['NotGreaterFullEqual', [8807, 824]], ['NotGreaterGreater', [8811, 824]], ['NotGreaterLess', [8825]], ['NotGreaterSlantEqual', [10878, 824]], ['NotGreaterTilde', [8821]], ['NotHumpDownHump', [8782, 824]], ['NotHumpEqual', [8783, 824]], ['notin', [8713]], ['notindot', [8949, 824]], ['notinE', [8953, 824]], ['notinva', [8713]], ['notinvb', [8951]], ['notinvc', [8950]], ['NotLeftTriangleBar', [10703, 824]], ['NotLeftTriangle', [8938]], ['NotLeftTriangleEqual', [8940]], ['NotLess', [8814]], ['NotLessEqual', [8816]], ['NotLessGreater', [8824]], ['NotLessLess', [8810, 824]], ['NotLessSlantEqual', [10877, 824]], ['NotLessTilde', [8820]], ['NotNestedGreaterGreater', [10914, 824]], ['NotNestedLessLess', [10913, 824]], ['notni', [8716]], ['notniva', [8716]], ['notnivb', [8958]], ['notnivc', [8957]], ['NotPrecedes', [8832]], ['NotPrecedesEqual', [10927, 824]], ['NotPrecedesSlantEqual', [8928]], ['NotReverseElement', [8716]], ['NotRightTriangleBar', [10704, 824]], ['NotRightTriangle', [8939]], ['NotRightTriangleEqual', [8941]], ['NotSquareSubset', [8847, 824]], ['NotSquareSubsetEqual', [8930]], ['NotSquareSuperset', [8848, 824]], ['NotSquareSupersetEqual', [8931]], ['NotSubset', [8834, 8402]], ['NotSubsetEqual', [8840]], ['NotSucceeds', [8833]], ['NotSucceedsEqual', [10928, 824]], ['NotSucceedsSlantEqual', [8929]], ['NotSucceedsTilde', [8831, 824]], ['NotSuperset', [8835, 8402]], ['NotSupersetEqual', [8841]], ['NotTilde', [8769]], ['NotTildeEqual', [8772]], ['NotTildeFullEqual', [8775]], ['NotTildeTilde', [8777]], ['NotVerticalBar', [8740]], ['nparallel', [8742]], ['npar', [8742]], ['nparsl', [11005, 8421]], ['npart', [8706, 824]], ['npolint', [10772]], ['npr', [8832]], ['nprcue', [8928]], ['nprec', [8832]], ['npreceq', [10927, 824]], ['npre', [10927, 824]], ['nrarrc', [10547, 824]], ['nrarr', [8603]], ['nrArr', [8655]], ['nrarrw', [8605, 824]], ['nrightarrow', [8603]], ['nRightarrow', [8655]], ['nrtri', [8939]], ['nrtrie', [8941]], ['nsc', [8833]], ['nsccue', [8929]], ['nsce', [10928, 824]], ['Nscr', [119977]], ['nscr', [120003]], ['nshortmid', [8740]], ['nshortparallel', [8742]], ['nsim', [8769]], ['nsime', [8772]], ['nsimeq', [8772]], ['nsmid', [8740]], ['nspar', [8742]], ['nsqsube', [8930]], ['nsqsupe', [8931]], ['nsub', [8836]], ['nsubE', [10949, 824]], ['nsube', [8840]], ['nsubset', [8834, 8402]], ['nsubseteq', [8840]], ['nsubseteqq', [10949, 824]], ['nsucc', [8833]], ['nsucceq', [10928, 824]], ['nsup', [8837]], ['nsupE', [10950, 824]], ['nsupe', [8841]], ['nsupset', [8835, 8402]], ['nsupseteq', [8841]], ['nsupseteqq', [10950, 824]], ['ntgl', [8825]], ['Ntilde', [209]], ['ntilde', [241]], ['ntlg', [8824]], ['ntriangleleft', [8938]], ['ntrianglelefteq', [8940]], ['ntriangleright', [8939]], ['ntrianglerighteq', [8941]], ['Nu', [925]], ['nu', [957]], ['num', [35]], ['numero', [8470]], ['numsp', [8199]], ['nvap', [8781, 8402]], ['nvdash', [8876]], ['nvDash', [8877]], ['nVdash', [8878]], ['nVDash', [8879]], ['nvge', [8805, 8402]], ['nvgt', [62, 8402]], ['nvHarr', [10500]], ['nvinfin', [10718]], ['nvlArr', [10498]], ['nvle', [8804, 8402]], ['nvlt', [60, 8402]], ['nvltrie', [8884, 8402]], ['nvrArr', [10499]], ['nvrtrie', [8885, 8402]], ['nvsim', [8764, 8402]], ['nwarhk', [10531]], ['nwarr', [8598]], ['nwArr', [8662]], ['nwarrow', [8598]], ['nwnear', [10535]], ['Oacute', [211]], ['oacute', [243]], ['oast', [8859]], ['Ocirc', [212]], ['ocirc', [244]], ['ocir', [8858]], ['Ocy', [1054]], ['ocy', [1086]], ['odash', [8861]], ['Odblac', [336]], ['odblac', [337]], ['odiv', [10808]], ['odot', [8857]], ['odsold', [10684]], ['OElig', [338]], ['oelig', [339]], ['ofcir', [10687]], ['Ofr', [120082]], ['ofr', [120108]], ['ogon', [731]], ['Ograve', [210]], ['ograve', [242]], ['ogt', [10689]], ['ohbar', [10677]], ['ohm', [937]], ['oint', [8750]], ['olarr', [8634]], ['olcir', [10686]], ['olcross', [10683]], ['oline', [8254]], ['olt', [10688]], ['Omacr', [332]], ['omacr', [333]], ['Omega', [937]], ['omega', [969]], ['Omicron', [927]], ['omicron', [959]], ['omid', [10678]], ['ominus', [8854]], ['Oopf', [120134]], ['oopf', [120160]], ['opar', [10679]], ['OpenCurlyDoubleQuote', [8220]], ['OpenCurlyQuote', [8216]], ['operp', [10681]], ['oplus', [8853]], ['orarr', [8635]], ['Or', [10836]], ['or', [8744]], ['ord', [10845]], ['order', [8500]], ['orderof', [8500]], ['ordf', [170]], ['ordm', [186]], ['origof', [8886]], ['oror', [10838]], ['orslope', [10839]], ['orv', [10843]], ['oS', [9416]], ['Oscr', [119978]], ['oscr', [8500]], ['Oslash', [216]], ['oslash', [248]], ['osol', [8856]], ['Otilde', [213]], ['otilde', [245]], ['otimesas', [10806]], ['Otimes', [10807]], ['otimes', [8855]], ['Ouml', [214]], ['ouml', [246]], ['ovbar', [9021]], ['OverBar', [8254]], ['OverBrace', [9182]], ['OverBracket', [9140]], ['OverParenthesis', [9180]], ['para', [182]], ['parallel', [8741]], ['par', [8741]], ['parsim', [10995]], ['parsl', [11005]], ['part', [8706]], ['PartialD', [8706]], ['Pcy', [1055]], ['pcy', [1087]], ['percnt', [37]], ['period', [46]], ['permil', [8240]], ['perp', [8869]], ['pertenk', [8241]], ['Pfr', [120083]], ['pfr', [120109]], ['Phi', [934]], ['phi', [966]], ['phiv', [981]], ['phmmat', [8499]], ['phone', [9742]], ['Pi', [928]], ['pi', [960]], ['pitchfork', [8916]], ['piv', [982]], ['planck', [8463]], ['planckh', [8462]], ['plankv', [8463]], ['plusacir', [10787]], ['plusb', [8862]], ['pluscir', [10786]], ['plus', [43]], ['plusdo', [8724]], ['plusdu', [10789]], ['pluse', [10866]], ['PlusMinus', [177]], ['plusmn', [177]], ['plussim', [10790]], ['plustwo', [10791]], ['pm', [177]], ['Poincareplane', [8460]], ['pointint', [10773]], ['popf', [120161]], ['Popf', [8473]], ['pound', [163]], ['prap', [10935]], ['Pr', [10939]], ['pr', [8826]], ['prcue', [8828]], ['precapprox', [10935]], ['prec', [8826]], ['preccurlyeq', [8828]], ['Precedes', [8826]], ['PrecedesEqual', [10927]], ['PrecedesSlantEqual', [8828]], ['PrecedesTilde', [8830]], ['preceq', [10927]], ['precnapprox', [10937]], ['precneqq', [10933]], ['precnsim', [8936]], ['pre', [10927]], ['prE', [10931]], ['precsim', [8830]], ['prime', [8242]], ['Prime', [8243]], ['primes', [8473]], ['prnap', [10937]], ['prnE', [10933]], ['prnsim', [8936]], ['prod', [8719]], ['Product', [8719]], ['profalar', [9006]], ['profline', [8978]], ['profsurf', [8979]], ['prop', [8733]], ['Proportional', [8733]], ['Proportion', [8759]], ['propto', [8733]], ['prsim', [8830]], ['prurel', [8880]], ['Pscr', [119979]], ['pscr', [120005]], ['Psi', [936]], ['psi', [968]], ['puncsp', [8200]], ['Qfr', [120084]], ['qfr', [120110]], ['qint', [10764]], ['qopf', [120162]], ['Qopf', [8474]], ['qprime', [8279]], ['Qscr', [119980]], ['qscr', [120006]], ['quaternions', [8461]], ['quatint', [10774]], ['quest', [63]], ['questeq', [8799]], ['quot', [34]], ['QUOT', [34]], ['rAarr', [8667]], ['race', [8765, 817]], ['Racute', [340]], ['racute', [341]], ['radic', [8730]], ['raemptyv', [10675]], ['rang', [10217]], ['Rang', [10219]], ['rangd', [10642]], ['range', [10661]], ['rangle', [10217]], ['raquo', [187]], ['rarrap', [10613]], ['rarrb', [8677]], ['rarrbfs', [10528]], ['rarrc', [10547]], ['rarr', [8594]], ['Rarr', [8608]], ['rArr', [8658]], ['rarrfs', [10526]], ['rarrhk', [8618]], ['rarrlp', [8620]], ['rarrpl', [10565]], ['rarrsim', [10612]], ['Rarrtl', [10518]], ['rarrtl', [8611]], ['rarrw', [8605]], ['ratail', [10522]], ['rAtail', [10524]], ['ratio', [8758]], ['rationals', [8474]], ['rbarr', [10509]], ['rBarr', [10511]], ['RBarr', [10512]], ['rbbrk', [10099]], ['rbrace', [125]], ['rbrack', [93]], ['rbrke', [10636]], ['rbrksld', [10638]], ['rbrkslu', [10640]], ['Rcaron', [344]], ['rcaron', [345]], ['Rcedil', [342]], ['rcedil', [343]], ['rceil', [8969]], ['rcub', [125]], ['Rcy', [1056]], ['rcy', [1088]], ['rdca', [10551]], ['rdldhar', [10601]], ['rdquo', [8221]], ['rdquor', [8221]], ['CloseCurlyDoubleQuote', [8221]], ['rdsh', [8627]], ['real', [8476]], ['realine', [8475]], ['realpart', [8476]], ['reals', [8477]], ['Re', [8476]], ['rect', [9645]], ['reg', [174]], ['REG', [174]], ['ReverseElement', [8715]], ['ReverseEquilibrium', [8651]], ['ReverseUpEquilibrium', [10607]], ['rfisht', [10621]], ['rfloor', [8971]], ['rfr', [120111]], ['Rfr', [8476]], ['rHar', [10596]], ['rhard', [8641]], ['rharu', [8640]], ['rharul', [10604]], ['Rho', [929]], ['rho', [961]], ['rhov', [1009]], ['RightAngleBracket', [10217]], ['RightArrowBar', [8677]], ['rightarrow', [8594]], ['RightArrow', [8594]], ['Rightarrow', [8658]], ['RightArrowLeftArrow', [8644]], ['rightarrowtail', [8611]], ['RightCeiling', [8969]], ['RightDoubleBracket', [10215]], ['RightDownTeeVector', [10589]], ['RightDownVectorBar', [10581]], ['RightDownVector', [8642]], ['RightFloor', [8971]], ['rightharpoondown', [8641]], ['rightharpoonup', [8640]], ['rightleftarrows', [8644]], ['rightleftharpoons', [8652]], ['rightrightarrows', [8649]], ['rightsquigarrow', [8605]], ['RightTeeArrow', [8614]], ['RightTee', [8866]], ['RightTeeVector', [10587]], ['rightthreetimes', [8908]], ['RightTriangleBar', [10704]], ['RightTriangle', [8883]], ['RightTriangleEqual', [8885]], ['RightUpDownVector', [10575]], ['RightUpTeeVector', [10588]], ['RightUpVectorBar', [10580]], ['RightUpVector', [8638]], ['RightVectorBar', [10579]], ['RightVector', [8640]], ['ring', [730]], ['risingdotseq', [8787]], ['rlarr', [8644]], ['rlhar', [8652]], ['rlm', [8207]], ['rmoustache', [9137]], ['rmoust', [9137]], ['rnmid', [10990]], ['roang', [10221]], ['roarr', [8702]], ['robrk', [10215]], ['ropar', [10630]], ['ropf', [120163]], ['Ropf', [8477]], ['roplus', [10798]], ['rotimes', [10805]], ['RoundImplies', [10608]], ['rpar', [41]], ['rpargt', [10644]], ['rppolint', [10770]], ['rrarr', [8649]], ['Rrightarrow', [8667]], ['rsaquo', [8250]], ['rscr', [120007]], ['Rscr', [8475]], ['rsh', [8625]], ['Rsh', [8625]], ['rsqb', [93]], ['rsquo', [8217]], ['rsquor', [8217]], ['CloseCurlyQuote', [8217]], ['rthree', [8908]], ['rtimes', [8906]], ['rtri', [9657]], ['rtrie', [8885]], ['rtrif', [9656]], ['rtriltri', [10702]], ['RuleDelayed', [10740]], ['ruluhar', [10600]], ['rx', [8478]], ['Sacute', [346]], ['sacute', [347]], ['sbquo', [8218]], ['scap', [10936]], ['Scaron', [352]], ['scaron', [353]], ['Sc', [10940]], ['sc', [8827]], ['sccue', [8829]], ['sce', [10928]], ['scE', [10932]], ['Scedil', [350]], ['scedil', [351]], ['Scirc', [348]], ['scirc', [349]], ['scnap', [10938]], ['scnE', [10934]], ['scnsim', [8937]], ['scpolint', [10771]], ['scsim', [8831]], ['Scy', [1057]], ['scy', [1089]], ['sdotb', [8865]], ['sdot', [8901]], ['sdote', [10854]], ['searhk', [10533]], ['searr', [8600]], ['seArr', [8664]], ['searrow', [8600]], ['sect', [167]], ['semi', [59]], ['seswar', [10537]], ['setminus', [8726]], ['setmn', [8726]], ['sext', [10038]], ['Sfr', [120086]], ['sfr', [120112]], ['sfrown', [8994]], ['sharp', [9839]], ['SHCHcy', [1065]], ['shchcy', [1097]], ['SHcy', [1064]], ['shcy', [1096]], ['ShortDownArrow', [8595]], ['ShortLeftArrow', [8592]], ['shortmid', [8739]], ['shortparallel', [8741]], ['ShortRightArrow', [8594]], ['ShortUpArrow', [8593]], ['shy', [173]], ['Sigma', [931]], ['sigma', [963]], ['sigmaf', [962]], ['sigmav', [962]], ['sim', [8764]], ['simdot', [10858]], ['sime', [8771]], ['simeq', [8771]], ['simg', [10910]], ['simgE', [10912]], ['siml', [10909]], ['simlE', [10911]], ['simne', [8774]], ['simplus', [10788]], ['simrarr', [10610]], ['slarr', [8592]], ['SmallCircle', [8728]], ['smallsetminus', [8726]], ['smashp', [10803]], ['smeparsl', [10724]], ['smid', [8739]], ['smile', [8995]], ['smt', [10922]], ['smte', [10924]], ['smtes', [10924, 65024]], ['SOFTcy', [1068]], ['softcy', [1100]], ['solbar', [9023]], ['solb', [10692]], ['sol', [47]], ['Sopf', [120138]], ['sopf', [120164]], ['spades', [9824]], ['spadesuit', [9824]], ['spar', [8741]], ['sqcap', [8851]], ['sqcaps', [8851, 65024]], ['sqcup', [8852]], ['sqcups', [8852, 65024]], ['Sqrt', [8730]], ['sqsub', [8847]], ['sqsube', [8849]], ['sqsubset', [8847]], ['sqsubseteq', [8849]], ['sqsup', [8848]], ['sqsupe', [8850]], ['sqsupset', [8848]], ['sqsupseteq', [8850]], ['square', [9633]], ['Square', [9633]], ['SquareIntersection', [8851]], ['SquareSubset', [8847]], ['SquareSubsetEqual', [8849]], ['SquareSuperset', [8848]], ['SquareSupersetEqual', [8850]], ['SquareUnion', [8852]], ['squarf', [9642]], ['squ', [9633]], ['squf', [9642]], ['srarr', [8594]], ['Sscr', [119982]], ['sscr', [120008]], ['ssetmn', [8726]], ['ssmile', [8995]], ['sstarf', [8902]], ['Star', [8902]], ['star', [9734]], ['starf', [9733]], ['straightepsilon', [1013]], ['straightphi', [981]], ['strns', [175]], ['sub', [8834]], ['Sub', [8912]], ['subdot', [10941]], ['subE', [10949]], ['sube', [8838]], ['subedot', [10947]], ['submult', [10945]], ['subnE', [10955]], ['subne', [8842]], ['subplus', [10943]], ['subrarr', [10617]], ['subset', [8834]], ['Subset', [8912]], ['subseteq', [8838]], ['subseteqq', [10949]], ['SubsetEqual', [8838]], ['subsetneq', [8842]], ['subsetneqq', [10955]], ['subsim', [10951]], ['subsub', [10965]], ['subsup', [10963]], ['succapprox', [10936]], ['succ', [8827]], ['succcurlyeq', [8829]], ['Succeeds', [8827]], ['SucceedsEqual', [10928]], ['SucceedsSlantEqual', [8829]], ['SucceedsTilde', [8831]], ['succeq', [10928]], ['succnapprox', [10938]], ['succneqq', [10934]], ['succnsim', [8937]], ['succsim', [8831]], ['SuchThat', [8715]], ['sum', [8721]], ['Sum', [8721]], ['sung', [9834]], ['sup1', [185]], ['sup2', [178]], ['sup3', [179]], ['sup', [8835]], ['Sup', [8913]], ['supdot', [10942]], ['supdsub', [10968]], ['supE', [10950]], ['supe', [8839]], ['supedot', [10948]], ['Superset', [8835]], ['SupersetEqual', [8839]], ['suphsol', [10185]], ['suphsub', [10967]], ['suplarr', [10619]], ['supmult', [10946]], ['supnE', [10956]], ['supne', [8843]], ['supplus', [10944]], ['supset', [8835]], ['Supset', [8913]], ['supseteq', [8839]], ['supseteqq', [10950]], ['supsetneq', [8843]], ['supsetneqq', [10956]], ['supsim', [10952]], ['supsub', [10964]], ['supsup', [10966]], ['swarhk', [10534]], ['swarr', [8601]], ['swArr', [8665]], ['swarrow', [8601]], ['swnwar', [10538]], ['szlig', [223]], ['Tab', [9]], ['target', [8982]], ['Tau', [932]], ['tau', [964]], ['tbrk', [9140]], ['Tcaron', [356]], ['tcaron', [357]], ['Tcedil', [354]], ['tcedil', [355]], ['Tcy', [1058]], ['tcy', [1090]], ['tdot', [8411]], ['telrec', [8981]], ['Tfr', [120087]], ['tfr', [120113]], ['there4', [8756]], ['therefore', [8756]], ['Therefore', [8756]], ['Theta', [920]], ['theta', [952]], ['thetasym', [977]], ['thetav', [977]], ['thickapprox', [8776]], ['thicksim', [8764]], ['ThickSpace', [8287, 8202]], ['ThinSpace', [8201]], ['thinsp', [8201]], ['thkap', [8776]], ['thksim', [8764]], ['THORN', [222]], ['thorn', [254]], ['tilde', [732]], ['Tilde', [8764]], ['TildeEqual', [8771]], ['TildeFullEqual', [8773]], ['TildeTilde', [8776]], ['timesbar', [10801]], ['timesb', [8864]], ['times', [215]], ['timesd', [10800]], ['tint', [8749]], ['toea', [10536]], ['topbot', [9014]], ['topcir', [10993]], ['top', [8868]], ['Topf', [120139]], ['topf', [120165]], ['topfork', [10970]], ['tosa', [10537]], ['tprime', [8244]], ['trade', [8482]], ['TRADE', [8482]], ['triangle', [9653]], ['triangledown', [9663]], ['triangleleft', [9667]], ['trianglelefteq', [8884]], ['triangleq', [8796]], ['triangleright', [9657]], ['trianglerighteq', [8885]], ['tridot', [9708]], ['trie', [8796]], ['triminus', [10810]], ['TripleDot', [8411]], ['triplus', [10809]], ['trisb', [10701]], ['tritime', [10811]], ['trpezium', [9186]], ['Tscr', [119983]], ['tscr', [120009]], ['TScy', [1062]], ['tscy', [1094]], ['TSHcy', [1035]], ['tshcy', [1115]], ['Tstrok', [358]], ['tstrok', [359]], ['twixt', [8812]], ['twoheadleftarrow', [8606]], ['twoheadrightarrow', [8608]], ['Uacute', [218]], ['uacute', [250]], ['uarr', [8593]], ['Uarr', [8607]], ['uArr', [8657]], ['Uarrocir', [10569]], ['Ubrcy', [1038]], ['ubrcy', [1118]], ['Ubreve', [364]], ['ubreve', [365]], ['Ucirc', [219]], ['ucirc', [251]], ['Ucy', [1059]], ['ucy', [1091]], ['udarr', [8645]], ['Udblac', [368]], ['udblac', [369]], ['udhar', [10606]], ['ufisht', [10622]], ['Ufr', [120088]], ['ufr', [120114]], ['Ugrave', [217]], ['ugrave', [249]], ['uHar', [10595]], ['uharl', [8639]], ['uharr', [8638]], ['uhblk', [9600]], ['ulcorn', [8988]], ['ulcorner', [8988]], ['ulcrop', [8975]], ['ultri', [9720]], ['Umacr', [362]], ['umacr', [363]], ['uml', [168]], ['UnderBar', [95]], ['UnderBrace', [9183]], ['UnderBracket', [9141]], ['UnderParenthesis', [9181]], ['Union', [8899]], ['UnionPlus', [8846]], ['Uogon', [370]], ['uogon', [371]], ['Uopf', [120140]], ['uopf', [120166]], ['UpArrowBar', [10514]], ['uparrow', [8593]], ['UpArrow', [8593]], ['Uparrow', [8657]], ['UpArrowDownArrow', [8645]], ['updownarrow', [8597]], ['UpDownArrow', [8597]], ['Updownarrow', [8661]], ['UpEquilibrium', [10606]], ['upharpoonleft', [8639]], ['upharpoonright', [8638]], ['uplus', [8846]], ['UpperLeftArrow', [8598]], ['UpperRightArrow', [8599]], ['upsi', [965]], ['Upsi', [978]], ['upsih', [978]], ['Upsilon', [933]], ['upsilon', [965]], ['UpTeeArrow', [8613]], ['UpTee', [8869]], ['upuparrows', [8648]], ['urcorn', [8989]], ['urcorner', [8989]], ['urcrop', [8974]], ['Uring', [366]], ['uring', [367]], ['urtri', [9721]], ['Uscr', [119984]], ['uscr', [120010]], ['utdot', [8944]], ['Utilde', [360]], ['utilde', [361]], ['utri', [9653]], ['utrif', [9652]], ['uuarr', [8648]], ['Uuml', [220]], ['uuml', [252]], ['uwangle', [10663]], ['vangrt', [10652]], ['varepsilon', [1013]], ['varkappa', [1008]], ['varnothing', [8709]], ['varphi', [981]], ['varpi', [982]], ['varpropto', [8733]], ['varr', [8597]], ['vArr', [8661]], ['varrho', [1009]], ['varsigma', [962]], ['varsubsetneq', [8842, 65024]], ['varsubsetneqq', [10955, 65024]], ['varsupsetneq', [8843, 65024]], ['varsupsetneqq', [10956, 65024]], ['vartheta', [977]], ['vartriangleleft', [8882]], ['vartriangleright', [8883]], ['vBar', [10984]], ['Vbar', [10987]], ['vBarv', [10985]], ['Vcy', [1042]], ['vcy', [1074]], ['vdash', [8866]], ['vDash', [8872]], ['Vdash', [8873]], ['VDash', [8875]], ['Vdashl', [10982]], ['veebar', [8891]], ['vee', [8744]], ['Vee', [8897]], ['veeeq', [8794]], ['vellip', [8942]], ['verbar', [124]], ['Verbar', [8214]], ['vert', [124]], ['Vert', [8214]], ['VerticalBar', [8739]], ['VerticalLine', [124]], ['VerticalSeparator', [10072]], ['VerticalTilde', [8768]], ['VeryThinSpace', [8202]], ['Vfr', [120089]], ['vfr', [120115]], ['vltri', [8882]], ['vnsub', [8834, 8402]], ['vnsup', [8835, 8402]], ['Vopf', [120141]], ['vopf', [120167]], ['vprop', [8733]], ['vrtri', [8883]], ['Vscr', [119985]], ['vscr', [120011]], ['vsubnE', [10955, 65024]], ['vsubne', [8842, 65024]], ['vsupnE', [10956, 65024]], ['vsupne', [8843, 65024]], ['Vvdash', [8874]], ['vzigzag', [10650]], ['Wcirc', [372]], ['wcirc', [373]], ['wedbar', [10847]], ['wedge', [8743]], ['Wedge', [8896]], ['wedgeq', [8793]], ['weierp', [8472]], ['Wfr', [120090]], ['wfr', [120116]], ['Wopf', [120142]], ['wopf', [120168]], ['wp', [8472]], ['wr', [8768]], ['wreath', [8768]], ['Wscr', [119986]], ['wscr', [120012]], ['xcap', [8898]], ['xcirc', [9711]], ['xcup', [8899]], ['xdtri', [9661]], ['Xfr', [120091]], ['xfr', [120117]], ['xharr', [10231]], ['xhArr', [10234]], ['Xi', [926]], ['xi', [958]], ['xlarr', [10229]], ['xlArr', [10232]], ['xmap', [10236]], ['xnis', [8955]], ['xodot', [10752]], ['Xopf', [120143]], ['xopf', [120169]], ['xoplus', [10753]], ['xotime', [10754]], ['xrarr', [10230]], ['xrArr', [10233]], ['Xscr', [119987]], ['xscr', [120013]], ['xsqcup', [10758]], ['xuplus', [10756]], ['xutri', [9651]], ['xvee', [8897]], ['xwedge', [8896]], ['Yacute', [221]], ['yacute', [253]], ['YAcy', [1071]], ['yacy', [1103]], ['Ycirc', [374]], ['ycirc', [375]], ['Ycy', [1067]], ['ycy', [1099]], ['yen', [165]], ['Yfr', [120092]], ['yfr', [120118]], ['YIcy', [1031]], ['yicy', [1111]], ['Yopf', [120144]], ['yopf', [120170]], ['Yscr', [119988]], ['yscr', [120014]], ['YUcy', [1070]], ['yucy', [1102]], ['yuml', [255]], ['Yuml', [376]], ['Zacute', [377]], ['zacute', [378]], ['Zcaron', [381]], ['zcaron', [382]], ['Zcy', [1047]], ['zcy', [1079]], ['Zdot', [379]], ['zdot', [380]], ['zeetrf', [8488]], ['ZeroWidthSpace', [8203]], ['Zeta', [918]], ['zeta', [950]], ['zfr', [120119]], ['Zfr', [8488]], ['ZHcy', [1046]], ['zhcy', [1078]], ['zigrarr', [8669]], ['zopf', [120171]], ['Zopf', [8484]], ['Zscr', [119989]], ['zscr', [120015]], ['zwj', [8205]], ['zwnj', [8204]]];
	
	var alphaIndex = {};
	var charIndex = {};
	
	createIndexes(alphaIndex, charIndex);
	
	/**
	 * @constructor
	 */
	function Html5Entities() {}
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html5Entities.prototype.decode = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    return str.replace(/&(#?[\w\d]+);?/g, function(s, entity) {
	        var chr;
	        if (entity.charAt(0) === "#") {
	            var code = entity.charAt(1) === 'x' ?
	                parseInt(entity.substr(2).toLowerCase(), 16) :
	                parseInt(entity.substr(1));
	
	            if (!(isNaN(code) || code < -32768 || code > 65535)) {
	                chr = String.fromCharCode(code);
	            }
	        } else {
	            chr = alphaIndex[entity];
	        }
	        return chr || s;
	    });
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 Html5Entities.decode = function(str) {
	    return new Html5Entities().decode(str);
	 };
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html5Entities.prototype.encode = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLength = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLength) {
	        var charInfo = charIndex[str.charCodeAt(i)];
	        if (charInfo) {
	            var alpha = charInfo[str.charCodeAt(i + 1)];
	            if (alpha) {
	                i++;
	            } else {
	                alpha = charInfo[''];
	            }
	            if (alpha) {
	                result += "&" + alpha + ";";
	                i++;
	                continue;
	            }
	        }
	        result += str.charAt(i);
	        i++;
	    }
	    return result;
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 Html5Entities.encode = function(str) {
	    return new Html5Entities().encode(str);
	 };
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html5Entities.prototype.encodeNonUTF = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLength = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLength) {
	        var c = str.charCodeAt(i);
	        var charInfo = charIndex[c];
	        if (charInfo) {
	            var alpha = charInfo[str.charCodeAt(i + 1)];
	            if (alpha) {
	                i++;
	            } else {
	                alpha = charInfo[''];
	            }
	            if (alpha) {
	                result += "&" + alpha + ";";
	                i++;
	                continue;
	            }
	        }
	        if (c < 32 || c > 126) {
	            result += '&#' + c + ';';
	        } else {
	            result += str.charAt(i);
	        }
	        i++;
	    }
	    return result;
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 Html5Entities.encodeNonUTF = function(str) {
	    return new Html5Entities().encodeNonUTF(str);
	 };
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html5Entities.prototype.encodeNonASCII = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLength = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLength) {
	        var c = str.charCodeAt(i);
	        if (c <= 255) {
	            result += str[i++];
	            continue;
	        }
	        result += '&#' + c + ';';
	        i++
	    }
	    return result;
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 Html5Entities.encodeNonASCII = function(str) {
	    return new Html5Entities().encodeNonASCII(str);
	 };
	
	/**
	 * @param {Object} alphaIndex Passed by reference.
	 * @param {Object} charIndex Passed by reference.
	 */
	function createIndexes(alphaIndex, charIndex) {
	    var i = ENTITIES.length;
	    var _results = [];
	    while (i--) {
	        var e = ENTITIES[i];
	        var alpha = e[0];
	        var chars = e[1];
	        var chr = chars[0];
	        var addChar = (chr < 32 || chr > 126) || chr === 62 || chr === 60 || chr === 38 || chr === 34 || chr === 39;
	        var charInfo;
	        if (addChar) {
	            charInfo = charIndex[chr] = charIndex[chr] || {};
	        }
	        if (chars[1]) {
	            var chr2 = chars[1];
	            alphaIndex[alpha] = String.fromCharCode(chr) + String.fromCharCode(chr2);
	            _results.push(addChar && (charInfo[chr2] = alpha));
	        } else {
	            alphaIndex[alpha] = String.fromCharCode(chr);
	            _results.push(addChar && (charInfo[''] = alpha));
	        }
	    }
	}
	
	module.exports = Html5Entities;


/***/ }),

/***/ 144:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(14);
	var sprite = __webpack_require__(15);
	var symbol = new SpriteSymbol({
	  "id": "shape-arrow-back-large",
	  "use": "shape-arrow-back-large-usage",
	  "viewBox": "0 0 38 32",
	  "content": "<symbol viewBox=\"0 0 38 32\" id=\"shape-arrow-back-large\"><path d=\"M34 14H9.745l6.971-6.971-2.13-2.115L4 15.5l10.586 10.586 2.115-2.115L9.745 17H34v-3z\" /></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(14);
	var sprite = __webpack_require__(15);
	var symbol = new SpriteSymbol({
	  "id": "shape-arrow-forward-large",
	  "use": "shape-arrow-forward-large-usage",
	  "viewBox": "0 0 38 32",
	  "content": "<symbol viewBox=\"0 0 38 32\" id=\"shape-arrow-forward-large\"><path d=\"M4 14h24.255l-6.971-6.971 2.13-2.115L34 15.5 23.414 26.086l-2.115-2.115L28.255 17H4v-3z\" /></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(14);
	var sprite = __webpack_require__(15);
	var symbol = new SpriteSymbol({
	  "id": "shape-check-16px",
	  "use": "shape-check-16px-usage",
	  "viewBox": "0 0 16 16",
	  "content": "<symbol viewBox=\"0 0 16 16\" fill-rule=\"evenodd\" id=\"shape-check-16px\"><path d=\"M6.45 10.13L3.694 7.374l-1.42 1.41L6.45 12.96l7.05-7.05-1.41-1.41-5.64 5.63z\" fill-rule=\"nonzero\" /></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(14);
	var sprite = __webpack_require__(15);
	var symbol = new SpriteSymbol({
	  "id": "shape-eye",
	  "use": "shape-eye-usage",
	  "viewBox": "0 0 16 16",
	  "content": "<symbol viewBox=\"0 0 16 16\" id=\"shape-eye\"><path d=\"M8 10.571c-1.406 0-2.545-1.15-2.545-2.571 0-1.421 1.139-2.571 2.545-2.571S10.545 6.579 10.545 8c0 1.421-1.139 2.571-2.545 2.571M8 3.5C3.958 3.5 1 8 1 8s2.958 4.5 7 4.5S15 8 15 8s-2.958-4.5-7-4.5z\" /></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(14);
	var sprite = __webpack_require__(15);
	var symbol = new SpriteSymbol({
	  "id": "shape-hero-curved-bottom",
	  "use": "shape-hero-curved-bottom-usage",
	  "viewBox": "0 0 1220 232",
	  "content": "<symbol viewBox=\"0 0 1220 232\" id=\"shape-hero-curved-bottom\"><path d=\"M2 0c.023 41 33.202 99.334 144.479 99.334 105.983 0 149.093-43.692 222.822-43.692 127.01 0 213.028 135.956 396.451 135.956C917.192 191.598 1093.57 99.047 1218 8h2v224H0V0h2\" /></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _presets = __webpack_require__(3);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _functions = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var curve = _presets.animation.curve,
	    speed = _presets.animation.speed;
	
	
	var widths = {
	  long: (0, _functions.toRem)(_presets2.default.baselineGrid * 4),
	  medium: (0, _functions.toRem)(_presets2.default.baselineGrid * 3),
	  short: (0, _functions.toRem)(_presets2.default.baselineGrid * 2.5),
	  active: (0, _functions.toRem)(27)
	};
	
	var menuToggle = /*#__PURE__*/(0, _reactEmotion.css)(_extends({}, _presets.buttonReset, {
	  position: 'relative',
	  width: (0, _functions.toRem)(_presets2.default.baselineGrid * 4),
	  height: (0, _functions.toRem)(_presets2.default.baselineGrid * 3),
	  cursor: 'pointer'
	}), 'label:menuToggle;');
	
	var menuToggleInner = /*#__PURE__*/(0, _reactEmotion.css)('display:block;position:absolute;width:', widths.long, ';height:3px;top:50%;right:0;margin-top:-1px;transition:width ', speed.default, ' ', curve.easeInOutCirc, ',transform ', speed.default, ' ', curve.easeInOutCirc, ';transform-origin:center;&::before,&::after{content:\'\';display:block;position:absolute;width:', widths.medium, ';height:3px;right:0;background-color:inherit;transform-origin:center;transition:transform ', speed.default, ' ', curve.easeInOutCirc, ',opacity ', speed.default, ' ', curve.easeInOutCirc, ',width ', speed.default, ' ', curve.easeInOutCirc, ';transition-delay:80ms;}&::before{transform:translateY(-7px);}&::after{transform:translateY(7px);}.menu-open &{width:', widths.active, ';transform:rotate(-225deg);&::before{opacity:0;width:', widths.active, ';transform:translateY(0);}&::after{width:', widths.active, ';transform:rotate(-90deg) translateY(0);}}', 'label:menuToggleInner;');
	
	var MenuToggle = function MenuToggle(_ref) {
	  var color = _ref.color,
	      onClick = _ref.onClick,
	      label = _ref.label,
	      styles = _ref.styles;
	  return _react2.default.createElement(
	    'button',
	    {
	      className: /*#__PURE__*/(0, _emotion.css)(menuToggle, ';', styles, ';', 'label:MenuToggle;'),
	
	      onClick: onClick,
	      'aria-label': label,
	      'aria-expanded': 'false'
	    },
	    _react2.default.createElement('span', {
	      className: /*#__PURE__*/(0, _emotion.css)(menuToggleInner, ';background-color:', color, ';', 'label:MenuToggle;')
	    })
	  );
	};
	
	MenuToggle.propTypes = {
	  color: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  styles: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func.isRequired
	};
	
	MenuToggle.defaultProps = {
	  color: _presets.colors.gray.copy,
	  label: 'Navigation Menu'
	};
	
	exports.default = MenuToggle;
	module.exports = exports['default'];

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _wolfy87Eventemitter = __webpack_require__(708);
	
	var _wolfy87Eventemitter2 = _interopRequireDefault(_wolfy87Eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var events = new _wolfy87Eventemitter2.default();
	
	exports.default = events;
	module.exports = exports['default'];

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(14);
	var sprite = __webpack_require__(15);
	var symbol = new SpriteSymbol({
	  "id": "baseline-mark",
	  "use": "baseline-mark-usage",
	  "viewBox": "0 0 23 16",
	  "content": "<symbol viewBox=\"0 0 23 16\" id=\"baseline-mark\"><path d=\"M14.96 5.366a.4.4 0 0 1-.334-.68l1.658-1.657a2.343 2.343 0 0 1 3.963 1.248.394.394 0 0 1-.338.45c-.943.127-3.456.448-4.95.64zm-1.99 7.605a2.343 2.343 0 0 1-3.314 0l-.974-.975a.4.4 0 0 1 .283-.683h4.697a.4.4 0 0 1 .283.683l-.975.975zM2.716 4.734a.4.4 0 0 1-.345-.459c.092-.468.317-.904.659-1.246a2.343 2.343 0 0 1 3.313 0L8 4.687a.4.4 0 0 1-.334.68c-1.493-.192-4.006-.513-4.95-.633zm18.538-3.362a4.687 4.687 0 0 0-6.627 0l-3.314 3.314L8 1.372A4.687 4.687 0 0 0 1.372 8L8 14.627v.001a4.685 4.685 0 0 0 6.626 0h.001L21.254 8a4.687 4.687 0 0 0 0-6.628\" /></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(14);
	var sprite = __webpack_require__(15);
	var symbol = new SpriteSymbol({
	  "id": "pixelmoxie-logo",
	  "use": "pixelmoxie-logo-usage",
	  "viewBox": "0 0 168 24",
	  "content": "<symbol viewBox=\"0 0 168 24\" id=\"pixelmoxie-logo\"><title>Pixelmoxie</title><path class=\"logo-mark\" d=\"M18.409 8.745a.4.4 0 0 1-.333-.68l2.279-2.279a2.93 2.93 0 0 1 4.972 1.677.393.393 0 0 1-.342.436c-1.149.153-4.713.608-6.576.846zm-2.197 9.468a2.928 2.928 0 0 1-4.142 0l-1.388-1.389a.401.401 0 0 1 .283-.683h6.353a.4.4 0 0 1 .283.683l-1.389 1.389zM3.297 7.905a.4.4 0 0 1-.347-.443c.092-.63.382-1.22.837-1.676a2.929 2.929 0 0 1 4.141 0l2.279 2.279a.4.4 0 1 1-.333.68l-6.577-.84zm23.271-4.189a5.857 5.857 0 0 0-8.284 0l-4.142 4.142L10 3.716A5.857 5.857 0 1 0 1.716 12L10 20.284l.001.001a5.856 5.856 0 0 0 8.282 0l.001-.001L26.568 12a5.861 5.861 0 0 0 0-8.284\" /><path d=\"M49.102 8.999c0-1.876-.7-3.425-1.874-4.375-1.174-.974-2.774-1.473-4.65-1.473H35.83v18.222h3.772v-6.425h2.851c1.926 0 3.551-.5 4.75-1.474 1.224-.949 1.899-2.524 1.899-4.475zm-3.797.075c0 1.701-1.526 2.377-3.027 2.377h-2.676V6.698h2.651c.576 0 1.051.075 1.501.225.876.275 1.551 1.025 1.551 2.151zm6.15-2.873c.449.45.974.675 1.573.675.625 0 1.174-.225 1.624-.675.425-.45.65-.95.65-1.575s-.225-1.175-.65-1.625a2.305 2.305 0 0 0-1.624-.65c-.599 0-1.124.225-1.573.65-.45.45-.65 1-.65 1.625s.2 1.125.65 1.575zm-.225 2.75v12.422h3.647V8.951H51.23zm14.123 12.422h4.074l-4.499-6.349 4.374-6.073h-3.999l-2.3 3.499-2.224-3.499H56.68l4.349 6.173-4.474 6.249h4.024l2.399-3.649 2.375 3.649z\" /><path d=\"M72.729 13.751c.075-.476.375-.977.85-1.452.5-.476 1.099-.701 1.849-.701.85 0 1.6.3 2 .751.4.45.6.926.65 1.402h-5.349zm8.923 2.422c.05-.3.075-.724.075-1.299 0-1.849-.575-3.351-1.725-4.5-1.15-1.149-2.624-1.723-4.474-1.723-1.174 0-2.274.274-3.274.849-1.025.599-1.824 1.373-2.424 2.373a6.281 6.281 0 0 0-.9 3.276c0 1.249.325 2.375.925 3.377.624.999 1.449 1.773 2.474 2.298 1.05.549 2.175.824 3.424.824 1.275 0 2.4-.325 3.424-.974a5.109 5.109 0 0 0 2.15-2.699l-2.999-1.026c-.175.5-.55.901-1.05 1.201-.5.301-1.025.476-1.575.476-.8 0-1.449-.226-2.024-.676-.575-.451-.925-1.026-1.025-1.777h8.998zm2.403-13.775h3.647v18.975h-3.647zm20.448 9.676c1.425 0 2.025.9 2.025 2.35v6.95h3.625v-7.75c0-2.85-1.3-4.95-4.35-4.95-1.75 0-2.925.6-4.15 1.975-.675-1.3-2.05-1.975-3.625-1.975a4.8 4.8 0 0 0-2.1.5 3.46 3.46 0 0 0-1.525 1.4h-.025l-.001-1.623h-3.572v12.422h3.622v-6.899c0-1.476.775-2.401 2.226-2.401 1.401 0 2.027.95 2.027 2.4v6.9h3.597v-6.95c0-1.425.8-2.35 2.226-2.35v.001zm7.875 3.125c0 1.2.325 2.3.925 3.3.6 1 1.4 1.75 2.425 2.325 1.05.55 2.175.825 3.425.825 1.225 0 2.375-.275 3.425-.85a6.38 6.38 0 0 0 2.475-2.35c.6-1 .9-2.1.9-3.325s-.3-2.325-.9-3.3a6.26 6.26 0 0 0-2.45-2.325c-1.025-.575-2.175-.85-3.4-.85-1.25 0-2.375.3-3.425.85a6.46 6.46 0 0 0-2.475 2.375c-.6 1-.925 2.1-.925 3.325zm4.6-2.325c.6-.6 1.325-.9 2.175-.9.875 0 1.6.3 2.2.9.6.6.875 1.35.875 2.275 0 .925-.275 1.7-.875 2.275-.6.6-1.325.9-2.175.9-.875 0-1.6-.3-2.2-.9-.575-.6-.875-1.35-.875-2.275 0-.925.3-1.675.875-2.275z\" /><path d=\"M134.278 21.373h4.074l-4.499-6.349 4.374-6.073h-3.999l-2.3 3.499-2.224-3.499h-4.099l4.349 6.173-4.474 6.249h4.024l2.399-3.649 2.375 3.649zm5.977-15.172c.449.45.974.675 1.573.675.625 0 1.174-.225 1.624-.675.425-.45.65-.95.65-1.575s-.225-1.175-.65-1.625a2.305 2.305 0 0 0-1.624-.65c-.599 0-1.124.225-1.573.65-.45.45-.65 1-.65 1.625s.2 1.125.65 1.575zm-.225 2.75v12.422h3.647V8.951h-3.647zm9.774 4.8c.075-.476.375-.977.85-1.452.5-.476 1.099-.701 1.849-.701.85 0 1.6.3 2 .751.4.45.6.926.65 1.402h-5.349zm8.923 2.422c.05-.3.075-.724.075-1.299 0-1.849-.575-3.351-1.725-4.5-1.15-1.149-2.624-1.723-4.474-1.723-1.174 0-2.274.274-3.274.849-1.025.599-1.824 1.373-2.424 2.373a6.281 6.281 0 0 0-.9 3.276c0 1.249.325 2.375.925 3.377.624.999 1.449 1.773 2.474 2.298 1.05.549 2.175.824 3.424.824 1.275 0 2.4-.325 3.424-.974a5.109 5.109 0 0 0 2.15-2.699l-2.999-1.026c-.175.5-.55.901-1.05 1.201-.5.301-1.025.476-1.575.476-.8 0-1.449-.226-2.024-.676-.575-.451-.925-1.026-1.025-1.777h8.998zm4.376 5.475c.7 0 1.299-.25 1.799-.75a2.417 2.417 0 0 0 .725-1.75c0-.7-.25-1.3-.725-1.8a2.53 2.53 0 0 0-1.799-.725c-.699 0-1.274.25-1.774.725-.499.5-.749 1.1-.749 1.8 0 .675.25 1.275.749 1.75.5.5 1.075.75 1.774.75z\" /></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(14);
	var sprite = __webpack_require__(15);
	var symbol = new SpriteSymbol({
	  "id": "shape-newsletter-curved-top",
	  "use": "shape-newsletter-curved-top-usage",
	  "viewBox": "0 0 704 111",
	  "content": "<symbol viewBox=\"0 0 704 111\" id=\"shape-newsletter-curved-top\"><path d=\"M704 110.316c-.013-23.737-42.641-60-96-60-50.212 0-70.198 24-120 24-83.532 0-125.807-60-232-60-94.675 0-183.961 38.657-256 91.368V0h704v110.316\" /></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(311);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(144);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _html5Entities = __webpack_require__(97);
	
	var _html5Entities2 = _interopRequireDefault(_html5Entities);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _color = __webpack_require__(8);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _config = __webpack_require__(13);
	
	var _presets = __webpack_require__(3);
	
	var _typography = __webpack_require__(7);
	
	var _functions = __webpack_require__(5);
	
	var _innerWrapper = __webpack_require__(9);
	
	var _innerWrapper2 = _interopRequireDefault(_innerWrapper);
	
	var _baselineMark = __webpack_require__(274);
	
	var _baselineMark2 = _interopRequireDefault(_baselineMark);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Import components
	var speed = _presets.animation.speed,
	    curve = _presets.animation.curve;
	
	
	var entities = new _html5Entities2.default();
	
	var linkColor = _presets.colors.accent.green;
	
	var footer = /*#__PURE__*/(0, _reactEmotion.css)('label:footer;');
	
	var footerWrapper = /*#__PURE__*/(0, _reactEmotion.css)('/* max-width:', (0, _functions.toRem)(_presets.baselineGrid * 144), ';*/', 'label:footerWrapper;');
	
	var footerInner = /*#__PURE__*/(0, _reactEmotion.css)('display:flex;flex-wrap:nowrap;flex-direction:column-reverse;padding:', (0, _functions.toRem)(_presets.baselineGrid * 4), ' 0;', _functions.mqObj.lapLarge, '{flex-direction:row;justify-content:space-between;padding:', (0, _functions.toRem)(_presets.baselineGrid * 6), ' 0;}', 'label:footerInner;');
	
	var footerCell = /*#__PURE__*/(0, _reactEmotion.css)('label:footerCell;');
	
	var footerCopy = /*#__PURE__*/(0, _reactEmotion.css)('padding:', (0, _functions.toRem)(_presets.baselineGrid * 2), ' 0;', _functions.mqObj.lapLarge, '{padding:0;}', 'label:footerCopy;');
	
	var copyright = /*#__PURE__*/(0, _reactEmotion.css)((0, _typography.adjustFontSizeTo)(16), ';', 'label:copyright;');
	
	var mark = /*#__PURE__*/(0, _reactEmotion.css)('display:inline-block;height:', (0, _functions.toRem)(10), ';width:auto;margin:0 ', (0, _functions.toRem)(_presets.baselineGrid), ' 0;vertical-align:baseline;fill:', _presets.colors.pixelmoxie, ';', 'label:mark;');
	
	var footerNav = /*#__PURE__*/(0, _reactEmotion.css)((0, _typography.adjustFontSizeTo)(16), ';margin-left:', (0, _functions.toRem)(-_presets.baselineGrid), ';padding:', (0, _functions.toRem)(_presets.baselineGrid * 2), ' 0;', _functions.mqObj.lapLarge, '{margin-left:0;margin-right:', (0, _functions.toRem)(-_presets.baselineGrid), ';padding:0;}', 'label:footerNav;');
	
	var footerLink = /*#__PURE__*/(0, _reactEmotion.css)('position:relative;padding:2px ', (0, _functions.toRem)(_presets.baselineGrid), ';text-decoration:none;color:', _presets.colors.gray.copy, ';transition:color ', speed.default, ' ', curve.default, ';&::before,&::after{content:\'\';display:block;position:absolute;left:', (0, _functions.toRem)(_presets.baselineGrid), ';right:', (0, _functions.toRem)(_presets.baselineGrid), ';transition:opacity 200ms ease;}&::before{z-index:-2;top:8%;bottom:8%;opacity:0;background-color:', (0, _color2.default)(linkColor).hsl().alpha(0.24).string(), ';}&::after{z-index:-1;bottom:8%;height:2px;opacity:1;background-color:', linkColor, ';}&:hover,&:active,&:focus{&::before,&::after{opacity:1;}}', 'label:footerLink;');
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: footer },
	    _react2.default.createElement(
	      _innerWrapper2.default,
	      { className: footerWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: footerInner },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _reactEmotion.cx)(footerCell, footerCopy) },
	          _react2.default.createElement(
	            'div',
	            { className: copyright },
	            entities.decode('&copy; 2018 Pixelmoxie'),
	            _react2.default.createElement(
	              'svg',
	              { className: mark, viewBox: _baselineMark2.default.viewBox },
	              _react2.default.createElement('use', { xlinkHref: '#' + _baselineMark2.default.id })
	            ),
	            'Lovingly crafted Tumblr themes.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _reactEmotion.cx)(footerCell, footerNav) },
	          _config.footerNavItems.sort(function (a, b) {
	            return a.order - b.order;
	          }).map(function (item, index) {
	            return _react2.default.createElement(
	              _gatsbyLink2.default,
	              { key: index, to: item.path, className: footerLink },
	              item.label
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	Footer.propTypes = {};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Import components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _reactHeadroom = __webpack_require__(660);
	
	var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);
	
	var _color = __webpack_require__(8);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _gray = __webpack_require__(10);
	
	var _gray2 = _interopRequireDefault(_gray);
	
	var _config = __webpack_require__(13);
	
	var _presets = __webpack_require__(3);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _functions = __webpack_require__(5);
	
	var _navigation = __webpack_require__(300);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _innerWrapper = __webpack_require__(9);
	
	var _innerWrapper2 = _interopRequireDefault(_innerWrapper);
	
	var _pixelmoxieLogo = __webpack_require__(324);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var curve = _presets.animation.curve,
	    speed = _presets.animation.speed;
	
	
	var headerOuter = /*#__PURE__*/(0, _reactEmotion.css)('padding-bottom:', (0, _functions.toRem)(_presets2.default.baselineGrid * 5), ';@media (min-width:', _config.navBreakpoint, 'px){padding:', (0, _functions.toRem)(_presets2.default.baselineGrid * 5), ' 0;}', 'label:headerOuter;');
	
	var headerInner = /*#__PURE__*/(0, _reactEmotion.css)('padding:', (0, _functions.toRem)(_presets2.default.baselineGrid * 3), ' 0;background-color:', (0, _color2.default)(_presets.colors.ui.bright).hsl().alpha(0.96).string(), ';box-shadow:0 1px 1px 0 ', (0, _gray2.default)(94), ';transition:transform ', speed.default, ' ', curve.default, ',box-shadow ', speed.default, ' ', curve.default, ';pointer-events:all;.headroom--unfixed &{transform:translate3d(0,0,0);background:transparent;box-shadow:none;}@media (min-width:', _config.navBreakpoint, 'px){transform:translate3d(0,', (0, _functions.toRem)(_presets2.default.baselineGrid * -5), ',0);}', 'label:headerInner;');
	
	var headerWrapper = /*#__PURE__*/(0, _reactEmotion.css)('display:flex;justify-content:space-between;', 'label:headerWrapper;');
	
	var headerBranding = /*#__PURE__*/(0, _reactEmotion.css)('height:', (0, _functions.toRem)(_presets2.default.baselineGrid * 4), ';overflow:hidden;display:flex;align-items:center;', 'label:headerBranding;');
	
	var headerTitle = /*#__PURE__*/(0, _reactEmotion.css)('height:', (0, _functions.toRem)(_presets2.default.baselineGrid * 3), ';font-size:', (0, _functions.toRem)(_presets2.default.baselineGrid * 3), ';line-height:1;margin:0;', 'label:headerTitle;');
	
	var headerTitleLink = {
	  label: 'headerTitleLink',
	  color: _presets.colors.gray.copy,
	  textDecoration: 'none',
	
	  '.dark-header .headroom--unfixed &': {
	    color: _presets.colors.ui.bright
	  }
	};
	
	var headerLogo = {
	  label: 'headerLogo',
	  display: 'inline-block',
	  verticalAlign: 'middle',
	  width: 168,
	  height: 24,
	  fill: _presets.colors.gray.copy,
	  pointerEvents: 'none',
	  transition: 'fill ' + speed.default + ' ' + curve.default,
	
	  '.dark-header .headroom--unfixed &': {
	    fill: _presets.colors.ui.bright
	  },
	
	  '.logo-mark': {
	    fill: _presets.colors.pixelmoxie,
	    transition: 'fill ' + speed.default + ' ' + curve.default
	  }
	};
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    _reactHeadroom2.default,
	    {
	      className: (0, _emotion.css)( /*#__PURE__*/(0, _reactEmotion.css)('position:relative;z-index:', _presets.zIndex[9], ';pointer-events:none;', 'label:Header;'))
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _emotion.css)(headerOuter)
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _emotion.css)(headerInner)
	        },
	        _react2.default.createElement(
	          _innerWrapper2.default,
	          {
	            className: (0, _emotion.css)(headerWrapper)
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _emotion.css)(headerBranding)
	            },
	            _react2.default.createElement(
	              'h1',
	              {
	                className: (0, _emotion.css)(headerTitle)
	              },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  className: (0, _emotion.css)(_extends({}, headerTitleLink)),
	                  to: '/' },
	                _react2.default.createElement(_pixelmoxieLogo.ReactComponent, {
	                  className: (0, _emotion.css)(_extends({}, headerLogo))
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(_navigation2.default, null)
	        )
	      )
	    )
	  );
	};
	
	Header.propTypes = {
	  headerTitle: _propTypes2.default.string
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _events = __webpack_require__(186);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _config = __webpack_require__(13);
	
	var _presets = __webpack_require__(3);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _functions = __webpack_require__(5);
	
	var _menuToggle = __webpack_require__(185);
	
	var _menuToggle2 = _interopRequireDefault(_menuToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var curve = _presets.animation.curve,
	    speed = _presets.animation.speed;
	
	
	var navToggle = /*#__PURE__*/(0, _emotion.css)('color:', _presets.colors.gray.copy, ';transition:color ', speed.default, ' ', curve.default, ';.dark-header .headroom--unfixed &{color:', _presets.colors.ui.bright, ';}@media (min-width:', _config.navBreakpoint, 'px){display:none;}', 'label:navToggle;');
	
	var navItem = /*#__PURE__*/(0, _emotion.css)('height:', (0, _functions.toRem)(_presets2.default.baselineGrid * 4), ';display:none;align-items:flex-end;margin:0 ', (0, _functions.toRem)(_presets2.default.baselineGrid * 2), ';@media (min-width:', _config.navBreakpoint, 'px){display:flex;}', 'label:navItem;');
	
	var linksPadding = new Proxy({
	  'top|bottom': (0, _functions.toRem)(_presets2.default.baselineGrid / 4),
	  'left|right': (0, _functions.toRem)(_presets2.default.baselineGrid / 2)
	}, {
	  get: function get(target, property) {
	    /* eslint-disable-next-line */
	    for (var k in target) {
	      if (new RegExp(k).test(property)) {
	        return target[k];
	      }
	    }
	
	    return null;
	  }
	});
	
	var siteNav = /*#__PURE__*/(0, _emotion.css)('height:', (0, _functions.toRem)(_presets2.default.baselineGrid * 4), ';display:flex;align-items:center;', 'label:siteNav;');
	
	var navLinks = /*#__PURE__*/(0, _emotion.css)('display:block;position:relative;line-height:', (0, _functions.toRem)(_presets2.default.baselineGrid * 3), ';padding:', linksPadding.top, ' ', linksPadding.left, ';font-weight:600;text-decoration:none;color:', _presets.colors.gray.copy, ';opacity:0.86;transition:all ', speed.default, ' ', curve.default, ';.dark-header .headroom--unfixed &{color:', _presets.colors.ui.bright, ';}&::before{content:\'\';display:block;position:absolute;left:', linksPadding.left, ';right:', linksPadding.right, ';bottom:', linksPadding.bottom, ';height:', _presets2.default.baselineGrid, 'px;background-color:', _presets.colors.accent.green, ';z-index:-1;opacity:1;transform:scale(0.86,0);transform-origin:center bottom;transition:opacity ', speed.fast, ' ', curve.default, ',transform ', speed.default, ' ', curve.default, ';transition-delay:100ms;pointer-events:none;}&.is-active{opacity:1;cursor:default;}&:not(.is-active){&:hover,&:active{opacity:1;&::before{opacity:0.72;transform:scale(1,1);transition-delay:0ms;}}}', 'label:navLinks;');
	
	var NavItem = function NavItem(_ref) {
	  var linkTo = _ref.linkTo,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _emotion.css)(navItem)
	    },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: linkTo, activeClassName: 'is-active', exact: true, className: (0, _emotion.css)(navLinks)
	      },
	      children
	    )
	  );
	};
	
	NavItem.propTypes = {
	  linkTo: _propTypes2.default.string,
	  children: _propTypes2.default.node.isRequired
	};
	
	var Navigation = function Navigation() {
	  return _react2.default.createElement(
	    'nav',
	    {
	      className: (0, _emotion.css)(siteNav)
	    },
	    _react2.default.createElement(_menuToggle2.default, {
	      label: 'Navigation Menu',
	      color: 'currentColor',
	      onClick: function onClick() {
	        _events2.default.trigger('navToggleClicked');
	      },
	      styles: navToggle
	    }),
	    _config.navItems.sort(function (a, b) {
	      return a.order - b.order;
	    }).map(function (item, index) {
	      return _react2.default.createElement(
	        NavItem,
	        { key: index, linkTo: item.path },
	        item.label
	      );
	    })
	  );
	};
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _classnames = __webpack_require__(190);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _color = __webpack_require__(8);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _defer = __webpack_require__(261);
	
	var _defer2 = _interopRequireDefault(_defer);
	
	var _noScroll = __webpack_require__(654);
	
	var _noScroll2 = _interopRequireDefault(_noScroll);
	
	var _events = __webpack_require__(186);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _config = __webpack_require__(13);
	
	var _presets = __webpack_require__(3);
	
	var _functions = __webpack_require__(5);
	
	var _typography = __webpack_require__(7);
	
	var _ease = __webpack_require__(320);
	
	var _innerWrapper = __webpack_require__(9);
	
	var _innerWrapper2 = _interopRequireDefault(_innerWrapper);
	
	var _menuToggle = __webpack_require__(185);
	
	var _menuToggle2 = _interopRequireDefault(_menuToggle);
	
	var _pixelmoxieLogo = __webpack_require__(275);
	
	var _pixelmoxieLogo2 = _interopRequireDefault(_pixelmoxieLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var curve = _presets.animation.curve,
	    speed = _presets.animation.speed;
	
	
	var MENU_OPEN_CLASSES = ['menu-open', 'prevent-scroll'];
	
	var logoColor = (0, _color2.default)(_presets.colors.ui.whisper).alpha(0.7).hsl().toString();
	
	// Staggered delays
	var transitionDelay = parseFloat(speed.fast);
	var staggeredDelays = Array(_config.navItems.length).fill().map(function (_, idx) {
	  return (0, _ease.easeInOut)(2)(1 / (_config.navItems.length - 1) * idx) * transitionDelay;
	});
	
	// Staggered offsets
	var verticalOffset = 24;
	var staggeredOffsets = Array(_config.navItems.length).fill().map(function (_, idx) {
	  return parseInt((0, _ease.easeInOut)(1)(1 / (_config.navItems.length - 1) * idx) * verticalOffset, 10);
	});
	
	var overlayLogo = /*#__PURE__*/(0, _reactEmotion.css)('display:inline-block;vertical-align:middle;width:168px;height:24px;margin:', (0, _functions.toRem)(_presets.baselineGrid * 0.5), ' 0;fill:', logoColor, ';opacity:0;transition:opacity ', speed.medium, ' ', curve.default, ';pointer-events:none;.menu-open &{opacity:1;}', 'label:overlayLogo;');
	
	var overlayTopBar = /*#__PURE__*/(0, _reactEmotion.css)('padding:', (0, _functions.toRem)(_presets.baselineGrid * 3), ' 0;display:flex;justify-content:space-between;align-items:center;', 'label:overlayTopBar;');
	
	var overlayMenuItem = /*#__PURE__*/(0, _reactEmotion.css)('display:block;padding:', (0, _functions.toRem)(_presets.baselineGrid), ';font-family:', _typography.options.headerFontFamily.join(','), ';font-size:', _typography.options.overlayFontSize, ';font-size:calc(', _typography.options.overlayFontSize, ' + 1.5625vw);font-weight:700;text-decoration:none;color:', _presets.colors.ui.bright, ';', 'label:overlayMenuItem;');
	
	var overlayMenuItemList = /*#__PURE__*/(0, _reactEmotion.css)('height:calc(100vh - ', (0, _functions.toRem)(_presets.baselineGrid * 10), ');padding:calc(', (0, _functions.toRem)(_presets.baselineGrid * 3), ' + 3.59vh) ', (0, _functions.toRem)(_presets.baselineGrid * 3), ';display:flex;flex-direction:column;justify-content:flex-start;overflow-y:scroll;-webkit-overflow-scrolling:touch;', 'label:overlayMenuItemList;');
	
	var overlayMenu = /*#__PURE__*/(0, _reactEmotion.css)('visibility:hidden;position:fixed;top:0;right:0;bottom:0;left:0;background-color:', _presets.colors.ui.flush, ';z-index:', _presets.zIndex[9], ';.menu-open &{visibility:visible;}', 'label:overlayMenu;');
	
	var listItemsStyles = {
	  textAlign: 'center',
	  opacity: 0,
	  transition: 'none'
	};
	
	var activeListItemsStyles = {
	  opacity: 1,
	  transform: 'translate(0px, 0px)',
	  transition: 'transform ' + speed.default + ' ' + curve.default + ', opacity ' + speed.medium + ' ' + curve.default
	};
	
	var MenuItem = function MenuItem(_ref) {
	  var idx = _ref.idx,
	      linkTo = _ref.linkTo,
	      children = _ref.children,
	      onClick = _ref.onClick;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _emotion.css)(_extends({}, listItemsStyles, {
	        transform: 'translate(-25vw, ' + staggeredOffsets[idx] + 'px)',
	        '.menu-open &': _extends({}, activeListItemsStyles, {
	          transitionDelay: staggeredDelays[idx] + 'ms'
	        })
	      }))
	    },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: linkTo, onClick: onClick, className: (0, _emotion.css)(overlayMenuItem)
	      },
	      children
	    )
	  );
	};
	
	MenuItem.propTypes = {
	  idx: _propTypes2.default.number.isRequired,
	  linkTo: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.node.isRequired,
	  onClick: _propTypes2.default.func.isRequired
	};
	
	var OverlayMenu = function (_Component) {
	  _inherits(OverlayMenu, _Component);
	
	  function OverlayMenu(props) {
	    _classCallCheck(this, OverlayMenu);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      isOpen: false
	    };
	
	    _this.toggleMenu = _this.toggleMenu.bind(_this);
	    return _this;
	  }
	
	  OverlayMenu.prototype.componentDidMount = function componentDidMount() {
	    _events2.default.on('navToggleClicked', this.toggleMenu);
	  };
	
	  OverlayMenu.prototype.componentWillUnmount = function componentWillUnmount() {
	    _events2.default.off('navToggleClicked', this.toggleMenu);
	  };
	
	  OverlayMenu.prototype.toggleMenu = function toggleMenu(state) {
	    var _this2 = this;
	
	    this.setState(function () {
	      if (state && Object.prototype.hasOwnProperty.call(state, 'isOpen')) {
	        return {
	          isOpen: state.isOpen
	        };
	      }
	
	      return {
	        isOpen: !_this2.state.isOpen
	      };
	    });
	
	    (0, _defer2.default)(function () {
	      if (_this2.state.isOpen) _noScroll2.default.on();else _noScroll2.default.off();
	    });
	  };
	
	  OverlayMenu.prototype.componentDidUpdate = function componentDidUpdate(nextProps, nextState) {
	    var _this3 = this;
	
	    if (Object.prototype.hasOwnProperty.call(nextState, 'isOpen')) {
	      setTimeout(function () {
	        if (_this3.state.isOpen) {
	          var _document$body$classL;
	
	          (_document$body$classL = document.body.classList).add.apply(_document$body$classL, MENU_OPEN_CLASSES);
	        } else {
	          var _document$body$classL2;
	
	          (_document$body$classL2 = document.body.classList).remove.apply(_document$body$classL2, MENU_OPEN_CLASSES);
	        }
	      }, 0);
	    }
	  };
	
	  OverlayMenu.prototype.render = function render() {
	    var _this4 = this;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _emotion.merge)((0, _emotion.css)(overlayMenu) + (' ' + (0, _classnames2.default)({ 'is-open': this.state.isOpen })))
	      },
	      _react2.default.createElement(
	        _innerWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _emotion.css)(overlayTopBar)
	          },
	          _react2.default.createElement(
	            'svg',
	            { viewBox: _pixelmoxieLogo2.default.viewBox, className: (0, _emotion.css)(overlayLogo)
	            },
	            _react2.default.createElement('use', { xlinkHref: '#' + _pixelmoxieLogo2.default.id })
	          ),
	          _react2.default.createElement(_menuToggle2.default, {
	            label: 'Navigation Menu',
	            color: _presets.colors.ui.bright,
	            onClick: function onClick() {
	              _this4.toggleMenu({ isOpen: false });
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _emotion.css)(overlayMenuItemList)
	          },
	          _config.navItems.sort(function (a, b) {
	            return a.order - b.order;
	          }).map(function (item, index) {
	            return _react2.default.createElement(
	              MenuItem,
	              {
	                key: index,
	                idx: index,
	                linkTo: item.path,
	                onClick: function onClick() {
	                  _this4.toggleMenu({ isOpen: false });
	                }
	              },
	              item.label
	            );
	          }),
	          this.props.children
	        )
	      )
	    );
	  };
	
	  return OverlayMenu;
	}(_react.Component);
	
	OverlayMenu.propTypes = {
	  children: _propTypes2.default.node
	};
	
	exports.default = OverlayMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _toTitleCase = __webpack_require__(20);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	var _config = __webpack_require__(13);
	
	var _typography = __webpack_require__(7);
	
	var _presets = __webpack_require__(3);
	
	var _functions = __webpack_require__(5);
	
	var _innerWrapper = __webpack_require__(9);
	
	var _innerWrapper2 = _interopRequireDefault(_innerWrapper);
	
	var _socialIconTwitter = __webpack_require__(327);
	
	var _socialIconFacebook = __webpack_require__(325);
	
	var _socialIconInstagram = __webpack_require__(326);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var curve = _presets.animation.curve,
	    speed = _presets.animation.speed;
	
	
	var iconsMap = new Map([['twitter', _socialIconTwitter.ReactComponent], ['facebook', _socialIconFacebook.ReactComponent], ['instagram', _socialIconInstagram.ReactComponent]]);
	
	var spacing = (0, _functions.fp)({
	  margin: [(0, _functions.toRem)(_presets.baselineGrid * 4) + ' auto', (0, _functions.toRem)(_presets.baselineGrid * 6) + ' auto', (0, _functions.toRem)(_presets.baselineGrid * 8) + ' auto']
	});
	
	var socialIcons = /*#__PURE__*/(0, _emotion.css)(spacing, ';', 'label:socialIcons;');
	
	var socialIconsWrapper = /*#__PURE__*/(0, _emotion.css)('display:flex;flex-direction:column;justify-content:center;max-width:', (0, _functions.toRem)(_presets.baselineGrid * 144), ';', _functions.mqObj.lap, '{flex-direction:row;flex-wrap:wrap;}', 'label:socialIconsWrapper;');
	
	var socialIconsCell = /*#__PURE__*/(0, _emotion.css)('align-self:center;text-align:center;padding:', (0, _functions.toRem)(_presets.baselineGrid * 2), ';font-family:', _typography.options.headerFontFamily.join(','), ';font-size:', (0, _functions.toRem)(_presets.baselineGrid * 3), ';line-height:', (0, _functions.toRem)(_presets.baselineGrid * 4), ';color:', _presets.colors.gray.gunpowder, ';', _functions.mqObj.lap, '{width:calc(50% - ', (0, _functions.toRem)(_presets.baselineGrid), ');}', _functions.mqObj.lapLarge, '{width:auto;}', 'label:socialIconsCell;');
	
	var socialIconsLink = /*#__PURE__*/(0, _emotion.css)('text-decoration:none;color:', _presets.colors.gray.gunpowder, ';transition:color ', speed.fast, ' ', curve.default, ';&:hover,&:active,&:focus{color:', _presets.colors.blue, ';}', 'label:socialIconsLink;');
	
	var socialIconsIcon = /*#__PURE__*/(0, _emotion.css)('display:inline-block;vertical-align:middle;margin-right:', (0, _functions.toRem)(_presets.baselineGrid), ';transform:translateY(', (0, _functions.toRem)(_presets.baselineGrid * -0.5), ');width:', (0, _functions.toRem)(_presets.baselineGrid * 6), ';[class$=\'layer\']{mix-blend-mode:hard-light;}.bottom-layer{fill:currentColor;}', 'label:socialIconsIcon;');
	
	var SocialIcons = function SocialIcons() {
	  return _react2.default.createElement(
	    'nav',
	    {
	      className: (0, _emotion.css)(socialIcons)
	    },
	    _react2.default.createElement(
	      _innerWrapper2.default,
	      { className: socialIconsWrapper, narrow: true },
	      _react2.default.createElement(
	        'span',
	        { className: socialIconsCell },
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _toTitleCase2.default)('Follow us on:')
	        )
	      ),
	      _config.socialLinks.sort(function (a, b) {
	        return a.order - b.order;
	      }).map(function (item, index) {
	        var Icon = iconsMap.get(String(item.label).toLowerCase());
	
	        return _react2.default.createElement(
	          'a',
	          {
	            key: index,
	            href: item.path,
	            className: (0, _emotion.cx)(socialIconsCell, socialIconsLink, String(item.label).toLowerCase()),
	            target: '_blank'
	          },
	          Icon && _react2.default.createElement(Icon, { className: (0, _emotion.cx)(socialIconsIcon, 'icon') }),
	          _react2.default.createElement(
	            'span',
	            null,
	            item.label
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = SocialIcons;
	module.exports = exports['default'];

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _color = __webpack_require__(8);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _presets = __webpack_require__(3);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(7);
	
	var _functions = __webpack_require__(5);
	
	var _gray = __webpack_require__(10);
	
	var _gray2 = _interopRequireDefault(_gray);
	
	var _innerWrapper = __webpack_require__(9);
	
	var _innerWrapper2 = _interopRequireDefault(_innerWrapper);
	
	var _button = __webpack_require__(34);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _shapeNewsletterCurvedTop = __webpack_require__(276);
	
	var _shapeNewsletterCurvedTop2 = _interopRequireDefault(_shapeNewsletterCurvedTop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-return-assign */
	
	
	var _presets$animation = _presets2.default.animation,
	    speed = _presets$animation.speed,
	    curve = _presets$animation.curve;
	
	var bp = '@media (min-width: 480px)';
	var paddingTop = 110 / 704 * 100 + '%';
	
	var formBackgroundColor = _presets.colors.accent.green;
	var formBackgroundAltColor = (0, _color2.default)(formBackgroundColor).rotate(8).lighten(0.24);
	var formTextColor = (0, _gray2.default)(32, 'cool');
	var formButtonColor = formTextColor;
	var formAccentColor = _presets.colors.blue;
	var formButtonColorHover = formAccentColor;
	var wavesColor = (0, _color2.default)(formBackgroundAltColor).hex().replace('#', '');
	var wavesStrokeWidth = 12;
	var formBackgroundGradient = '\n  linear-gradient(to top right, transparent 40%, ' + (0, _color2.default)(formBackgroundColor).rotate(16).lighten(0) + ')\n';
	
	var formMargin = (0, _functions.fp)({
	  margin: [(0, _functions.toRem)(_presets.baselineGrid * 4) + ' auto', (0, _functions.toRem)(_presets.baselineGrid * 6) + ' auto', (0, _functions.toRem)(_presets.baselineGrid * 8) + ' auto']
	});
	
	var cover = {
	  position: 'absolute',
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	};
	
	var subscribeFormWrapper = /*#__PURE__*/(0, _emotion.css)(formMargin, ';max-width:', (0, _functions.toRem)(_presets.baselineGrid * 144), ';', 'label:subscribeFormWrapper;');
	
	var subscribeForm = /*#__PURE__*/(0, _emotion.css)('position:relative;margin:', (0, _functions.toRem)(_presets.baselineGrid * -2), ' auto 0;padding:', (0, _functions.toRem)(_presets.baselineGrid * 3), ';color:', formTextColor, ';background-color:', formBackgroundColor, ';border-radius:', _presets2.default.radius.default, ';overflow:hidden;', _functions.mqObj.lap, '{padding:', (0, _functions.toRem)(_presets.baselineGrid * 4), ';}', _functions.mqObj.lapLarge, '{padding:', (0, _functions.toRem)(_presets.baselineGrid * 6), ';}', _functions.mqObj.desk, '{padding:', (0, _functions.toRem)(_presets.baselineGrid * 8), ';}', 'label:subscribeForm;');
	
	var blobForm = /*#__PURE__*/(0, _emotion.css)('margin:0 auto;padding-bottom:16% !important;border-bottom-left-radius:50% 18%;border-bottom-right-radius:50% 18%;', _functions.mqObj.lap, '{border-bottom-left-radius:50% 24%;border-bottom-right-radius:50% 24%;}', 'label:blobForm;');
	
	var subscribeFormWavyTop = /*#__PURE__*/(0, _emotion.css)('padding-top:calc(', paddingTop, ' + ', (0, _functions.toRem)(_presets.baselineGrid * 3), ');background-color:', formBackgroundColor, ';background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'250\' height=\'30\' viewBox=\'0 0 1000 120\'%3E%3Cg fill=\'none\' stroke=\'%23', wavesColor, '\' stroke-width=\'', wavesStrokeWidth, '\' %3E%3Cpath d=\'M-500 75c0 0 125-30 250-30S0 75 0 75s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30\'/%3E%3Cpath d=\'M-500 45c0 0 125-30 250-30S0 45 0 45s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30\'/%3E%3Cpath d=\'M-500 105c0 0 125-30 250-30S0 105 0 105s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30\'/%3E%3Cpath d=\'M-500 15c0 0 125-30 250-30S0 15 0 15s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30\'/%3E%3Cpath d=\'M-500-15c0 0 125-30 250-30S0-15 0-15s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30\'/%3E%3Cpath d=\'M-500 135c0 0 125-30 250-30S0 135 0 135s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30\'/%3E%3C/g%3E%3C/svg%3E"),', formBackgroundGradient, ';', _functions.mqObj.lap, '{padding-top:calc(', paddingTop, ' + ', (0, _functions.toRem)(_presets.baselineGrid * 4), ');}', _functions.mqObj.lapLarge, '{padding-top:calc(', paddingTop, ' + ', (0, _functions.toRem)(_presets.baselineGrid * 4), ');}', _functions.mqObj.desk, '{padding-top:calc(', paddingTop, ' + ', (0, _functions.toRem)(_presets.baselineGrid * 4), ');}', 'label:subscribeFormWavyTop;');
	
	var subscribeFormTop = /*#__PURE__*/(0, _emotion.css)('position:absolute;left:50%;top:0;width:100.44%;transform:translate(-50%,0);padding-bottom:', 110 / 704 * 100, '%;z-index:', _presets.zIndex[2], ';', 'label:subscribeFormTop;');
	
	var subscribeFormTopShape = /*#__PURE__*/(0, _emotion.css)(cover, ';display:block;fill:', _presets.colors.ui.bright, ';pointer-events:none;', 'label:subscribeFormTopShape;');
	
	var subscribeFormPlug = /*#__PURE__*/(0, _emotion.css)('margin-bottom:', (0, _functions.toRem)(_presets.baselineGrid * 2), ';font-family:', _typography.options.headerFontFamily.join(','), ';font-weight:', _typography.options.headerWeight, ';font-size:calc(', (0, _functions.toRem)(_presets.baselineGrid * 2), ' + ', (0, _functions.toVW)(_presets.baselineGrid * 2), ');line-height:1.2;', 'label:subscribeFormPlug;');
	
	var subscribeFormStatus = /*#__PURE__*/(0, _emotion.css)('display:inline-block;padding:', (0, _functions.toRem)(_presets.baselineGrid * 0.75), ' ', (0, _functions.toRem)(_presets.baselineGrid), ';line-height:1.2;color:', _presets.colors.ui.bright, ';background-color:', _presets.colors.gray.copy, ';border-radius:', _presets2.default.radius.default, ';&.error{background-color:hsl(352,100%,44%);}a{color:inherit;font-weight:bolder;}', 'label:subscribeFormStatus;');
	
	var subscribeFormFields = /*#__PURE__*/(0, _emotion.css)('display:flex;flex-wrap:wrap;position:relative;margin-top:', (0, _functions.toRem)(_presets.baselineGrid * 3), ';&::after{display:none;}', bp, '{flex-wrap:nowrap;padding:', (0, _functions.toRem)(_presets.baselineGrid), ' 0;border-bottom:4px solid ', formTextColor, ';&::after{display:block;position:absolute;height:0;left:0;bottom:-4px;border-bottom:4px solid ', formAccentColor, ';font-family:', _typography.options.headerFontFamily.join(','), ';font-size:calc(', (0, _functions.toRem)(_presets.baselineGrid * 2), ' + ', (0, _functions.toVW)(_presets.baselineGrid * 2), ');overflow:hidden;}}', _functions.mqObj.lap, '{margin-top:', (0, _functions.toRem)(_presets.baselineGrid * 4), ';}', _functions.mqObj.lapLarge, '{margin-top:', (0, _functions.toRem)(_presets.baselineGrid * 6), ';}', 'label:subscribeFormFields;');
	
	var autofill = /*#__PURE__*/(0, _emotion.keyframes)('to{background-color:transparent;color:', formAccentColor, ';}', 'label:autofill;');
	
	var subscribeFormInput = /*#__PURE__*/(0, _emotion.css)('flex:1 0 100%;align-self:flex-end;min-width:', (0, _functions.toRem)(200), ';font-family:', _typography.options.headerFontFamily.join(','), ';font-weight:', _typography.options.headerWeight, ';font-size:calc(', (0, _functions.toRem)(_presets.baselineGrid * 2), ' + ', (0, _functions.toVW)(_presets.baselineGrid * 2), ');background:none;border:none;padding:0;height:', (0, _functions.toRem)(_presets.baselineGrid * 5), ';line-height:', (0, _functions.toRem)(_presets.baselineGrid * 5), ';color:', formAccentColor, ';animation-name:', autofill, ';animation-fill-mode:both;', bp, '{flex:1;}&::placeholder{color:', formTextColor, ';opacity:1;}&:focus{outline:0;&::placeholder{opacity:0.7;}}&:-webkit-autofill{background-color:lime !important;}', 'label:subscribeFormInput;');
	
	var subscribeFormButton = /*#__PURE__*/(0, _emotion.css)('flex:0;margin:', (0, _functions.toRem)(_presets.baselineGrid * 2), ' 0 0;align-self:flex-end;white-space:nowrap;transition:opacity ', speed.default, ' ', curve.default, ',transform ', speed.default, ' ', curve.default, ',background ', speed.default, ' ', curve.default, ',color ', speed.default, ' ', curve.default, ';', bp, '{margin:0 0 0 ', (0, _functions.toRem)(_presets.baselineGrid), ';}&:hover,&:focus,&:active{color:', (0, _color2.default)(formButtonColorHover).isDark() ? _presets.colors.ui.bright : _presets.colors.gray.dark, ';background-color:', formButtonColorHover, ';}', 'label:subscribeFormButton;');
	
	var SubscribeForm = function (_Component) {
	  _inherits(SubscribeForm, _Component);
	
	  function SubscribeForm(props) {
	    _classCallCheck(this, SubscribeForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      name: '',
	      email: '',
	      changed: false
	    };
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  SubscribeForm.prototype.handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	    if (this.state.email.indexOf('@') > -1) this.props.onSubmitted({
	      FNAME: this.state.name,
	      EMAIL: this.state.email
	    });
	  };
	
	  SubscribeForm.prototype.handleChange = function handleChange(event) {
	    var _setState;
	
	    var target = event.target;
	    var value = target.value,
	        name = target.name;
	
	
	    this.setState((_setState = {}, _setState[name] = value, _setState));
	  };
	
	  SubscribeForm.prototype.render = function render() {
	    var _cx;
	
	    var _props = this.props,
	        status = _props.status,
	        message = _props.message,
	        blob = _props.blob;
	
	
	    return _react2.default.createElement(
	      _innerWrapper2.default,
	      { className: subscribeFormWrapper, narrow: true },
	      _react2.default.createElement(
	        'form',
	        {
	          onSubmit: this.handleSubmit,
	          className: (0, _emotion.cx)(subscribeForm, subscribeFormWavyTop, (_cx = {
	            'has-focus': this.state.hasFocus
	          }, _cx[blobForm] = blob, _cx))
	        },
	        _react2.default.createElement(
	          'div',
	          { className: subscribeFormTop },
	          _react2.default.createElement(
	            'svg',
	            { className: subscribeFormTopShape, viewBox: _shapeNewsletterCurvedTop2.default.viewBox },
	            _react2.default.createElement('use', { xlinkHref: '#' + _shapeNewsletterCurvedTop2.default.id })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: subscribeFormPlug },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Subscribe to our newsletter and be notified about new theme releases and updates.'
	          )
	        ),
	        status === 'sending' && _react2.default.createElement(
	          'div',
	          { className: subscribeFormStatus },
	          'Sending...'
	        ),
	        status === 'error' && _react2.default.createElement('div', {
	          className: (0, _emotion.cx)(subscribeFormStatus, 'error'),
	          dangerouslySetInnerHTML: { __html: message }
	        }),
	        status === 'success' && _react2.default.createElement('div', {
	          className: (0, _emotion.cx)(subscribeFormStatus, 'success'),
	          dangerouslySetInnerHTML: { __html: message }
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _emotion.merge)((0, _emotion.css)( /*#__PURE__*/(0, _emotion.css)('&::after{content:\'', this.state.email, '\';}', 'label:SubscribeForm;')) + (' ' + subscribeFormFields))
	          },
	          _react2.default.createElement('input', {
	            type: 'text',
	            name: 'name',
	            value: this.state.name,
	            placeholder: 'Your name',
	            className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)('display:none;', 'label:SubscribeForm;', 'label:SubscribeForm;')
	          }),
	          _react2.default.createElement('input', {
	            className: subscribeFormInput,
	            type: 'email',
	            name: 'email',
	            value: this.state.email,
	            placeholder: 'you@email.com',
	            onChange: this.handleChange
	          }),
	          _react2.default.createElement(
	            _button2.default,
	            {
	              type: 'submit',
	              className: subscribeFormButton,
	              backgroundColor: formButtonColor
	            },
	            'Sign Up'
	          )
	        )
	      )
	    );
	  };
	
	  return SubscribeForm;
	}(_react.Component);
	
	SubscribeForm.propTypes = {
	  status: _propTypes2.default.string,
	  message: _propTypes2.default.string,
	  onSubmitted: _propTypes2.default.func.isRequired,
	  blob: _propTypes2.default.bool
	};
	
	SubscribeForm.defaultProps = {
	  blob: true
	};
	
	exports.default = SubscribeForm;
	module.exports = exports['default'];

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(190);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactHelmet = __webpack_require__(33);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _kebabCase = __webpack_require__(74);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _html5Entities = __webpack_require__(97);
	
	var _html5Entities2 = _interopRequireDefault(_html5Entities);
	
	var _emotion = __webpack_require__(4);
	
	__webpack_require__(430);
	
	__webpack_require__(432);
	
	__webpack_require__(431);
	
	var _header = __webpack_require__(297);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(296);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _overlayMenu = __webpack_require__(301);
	
	var _overlayMenu2 = _interopRequireDefault(_overlayMenu);
	
	var _mailchimpSubscribe = __webpack_require__(299);
	
	var _mailchimpSubscribe2 = _interopRequireDefault(_mailchimpSubscribe);
	
	var _socialIcons = __webpack_require__(306);
	
	var _socialIcons2 = _interopRequireDefault(_socialIcons);
	
	__webpack_require__(433);
	
	var _config = __webpack_require__(13);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _functions = __webpack_require__(5);
	
	var _presets = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inject global styles
	/* eslint-disable */
	
	
	// Import `League Spartan` typeface
	
	
	// Import PrismJS theme
	(0, _emotion.injectGlobal)('.gatsby-image-wrapper{/* Enhance blur-up effect for gatsby images */\n  img[src^="data:image"]{filter:blur(calc(', (0, _functions.toRem)(_presets.baselineGrid), ' + 1vw));transform:scale(1.2);}}');
	/* eslint-enable */
	
	// Import SVG sprite symbols
	
	
	// Import config and presets
	
	
	// Import components
	
	
	// Import fonts
	var shapes = __webpack_require__(709);
	shapes.keys().reduce(function (images, key) {
	  images[(0, _kebabCase2.default)(key.replace(/.svg/, ''))] = shapes(key);
	  return images;
	}, {});
	
	var entities = new _html5Entities2.default();
	
	var Layout = function Layout(props) {
	  var children = props.children,
	      location = props.location;
	
	  var isThemePage = !!location.pathname.match('/theme/');
	  var isArticlePage = !!location.pathname.match('/article/');
	  var isSupportPage = !!location.pathname.match('/support');
	  var excludeNewsletter = function () {
	    return isSupportPage;
	  }();
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)('page', { 'theme-permalink': isThemePage }, { 'dark-header': isThemePage || isSupportPage || isArticlePage })
	    },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        titleTemplate: entities.decode('%s &bull; ' + _config2.default.siteTitle),
	        defaultTitle: _config2.default.siteTitle
	      },
	      _react2.default.createElement('meta', { name: 'twitter:site', content: '@pixelmoxie' }),
	      _react2.default.createElement('meta', { name: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { name: 'og:site_name', content: 'Pixelmoxie' }),
	      _react2.default.createElement('link', { rel: 'canonical', href: '' + _config2.default.siteUrl + location.pathname }),
	      _react2.default.createElement('html', { lang: 'en' }),
	      _react2.default.createElement('meta', { name: 'apple-mobile-web-app-title', content: 'pixelmoxie.net' }),
	      _react2.default.createElement('meta', { name: 'application-name', content: 'pixelmoxie.net' }),
	      _react2.default.createElement('meta', { name: 'msapplication-TileColor', content: '#f12267' }),
	      _react2.default.createElement('meta', { name: 'theme-color', content: '#ffffff' }),
	      _react2.default.createElement('link', { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png?v=xQzlYR7X0A' }),
	      _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png?v=xQzlYR7X0A' }),
	      _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png?v=xQzlYR7X0A' }),
	      _react2.default.createElement('link', { rel: 'manifest', href: '/site.webmanifest?v=xQzlYR7X0A' }),
	      _react2.default.createElement('link', { rel: 'mask-icon', href: '/safari-pinned-tab.svg?v=xQzlYR7X0A', color: '#f12267' }),
	      _react2.default.createElement('link', { rel: 'shortcut icon', href: '/favicon.ico?v=xQzlYR7X0A' })
	    ),
	    _react2.default.createElement(_header2.default, { siteTitle: _config2.default.siteTitle }),
	    _react2.default.createElement(_overlayMenu2.default, null),
	    children(),
	    !excludeNewsletter && _react2.default.createElement(_mailchimpSubscribe2.default, { url: _config.mailChimpURL }),
	    _react2.default.createElement(_socialIcons2.default, null),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	Layout.propTypes = {
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.func,
	  location: _propTypes2.default.object
	};
	
	exports.default = Layout;
	module.exports = exports['default'];

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/* eslint-disable no-restricted-properties */
	var easeIn = function easeIn(p) {
	  return function (t) {
	    return Math.pow(t, p);
	  };
	};
	var easeOut = function easeOut(p) {
	  return function (t) {
	    return 1 - Math.abs(Math.pow(t - 1, p));
	  };
	};
	var easeInOut = function easeInOut(p) {
	  return function (t) {
	    return t < 0.5 ? easeIn(p)(t * 2) / 2 : easeOut(p)(t * 2 - 1) / 2 + 0.5;
	  };
	};
	
	exports.default = {
	  easeIn: easeIn,
	  easeOut: easeOut,
	  easeInOut: easeInOut,
	  linear: easeInOut(1),
	  easeInQuad: easeIn(2),
	  easeOutQuad: easeOut(2),
	  easeInOutQuad: easeInOut(2),
	  easeInCubic: easeIn(3),
	  easeOutCubic: easeOut(3),
	  easeInOutCubic: easeInOut(3),
	  easeInQuart: easeIn(4),
	  easeOutQuart: easeOut(4),
	  easeInOutQuart: easeInOut(4),
	  easeInQuint: easeIn(5),
	  easeOutQuint: easeOut(5),
	  easeInOutQuint: easeInOut(5)
	};
	module.exports = exports["default"];

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("title", null, "Pixelmoxie");
	
	var _ref2 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "logo-mark",
	  fill: "currentColor",
	  d: "M18.409 8.745a.4.4 0 0 1-.333-.68l2.279-2.279a2.93 2.93 0 0 1 4.972 1.677.393.393 0 0 1-.342.436c-1.149.153-4.713.608-6.576.846zm-2.197 9.468a2.928 2.928 0 0 1-4.142 0l-1.388-1.389a.401.401 0 0 1 .283-.683h6.353a.4.4 0 0 1 .283.683l-1.389 1.389zM3.297 7.905a.4.4 0 0 1-.347-.443c.092-.63.382-1.22.837-1.676a2.929 2.929 0 0 1 4.141 0l2.279 2.279a.4.4 0 1 1-.333.68l-6.577-.84zm23.271-4.189a5.857 5.857 0 0 0-8.284 0l-4.142 4.142L10 3.716A5.857 5.857 0 1 0 1.716 12L10 20.284l.001.001a5.856 5.856 0 0 0 8.282 0l.001-.001L26.568 12a5.861 5.861 0 0 0 0-8.284"
	});
	
	var _ref3 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M49.102 8.999c0-1.876-.7-3.425-1.874-4.375-1.174-.974-2.774-1.473-4.65-1.473H35.83v18.222h3.772v-6.425h2.851c1.926 0 3.551-.5 4.75-1.474 1.224-.949 1.899-2.524 1.899-4.475zm-3.797.075c0 1.701-1.526 2.377-3.027 2.377h-2.676V6.698h2.651c.576 0 1.051.075 1.501.225.876.275 1.551 1.025 1.551 2.151zm6.15-2.873c.449.45.974.675 1.573.675.625 0 1.174-.225 1.624-.675.425-.45.65-.95.65-1.575s-.225-1.175-.65-1.625a2.305 2.305 0 0 0-1.624-.65c-.599 0-1.124.225-1.573.65-.45.45-.65 1-.65 1.625s.2 1.125.65 1.575zm-.225 2.75v12.422h3.647V8.951H51.23zm14.123 12.422h4.074l-4.499-6.349 4.374-6.073h-3.999l-2.3 3.499-2.224-3.499H56.68l4.349 6.173-4.474 6.249h4.024l2.399-3.649 2.375 3.649z"
	});
	
	var _ref4 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M72.729 13.751c.075-.476.375-.977.85-1.452.5-.476 1.099-.701 1.849-.701.85 0 1.6.3 2 .751.4.45.6.926.65 1.402h-5.349zm8.923 2.422c.05-.3.075-.724.075-1.299 0-1.849-.575-3.351-1.725-4.5-1.15-1.149-2.624-1.723-4.474-1.723-1.174 0-2.274.274-3.274.849-1.025.599-1.824 1.373-2.424 2.373a6.281 6.281 0 0 0-.9 3.276c0 1.249.325 2.375.925 3.377.624.999 1.449 1.773 2.474 2.298 1.05.549 2.175.824 3.424.824 1.275 0 2.4-.325 3.424-.974a5.109 5.109 0 0 0 2.15-2.699l-2.999-1.026c-.175.5-.55.901-1.05 1.201-.5.301-1.025.476-1.575.476-.8 0-1.449-.226-2.024-.676-.575-.451-.925-1.026-1.025-1.777h8.998zm2.403-13.775h3.647v18.975h-3.647zm20.448 9.676c1.425 0 2.025.9 2.025 2.35v6.95h3.625v-7.75c0-2.85-1.3-4.95-4.35-4.95-1.75 0-2.925.6-4.15 1.975-.675-1.3-2.05-1.975-3.625-1.975a4.8 4.8 0 0 0-2.1.5 3.46 3.46 0 0 0-1.525 1.4h-.025l-.001-1.623h-3.572v12.422h3.622v-6.899c0-1.476.775-2.401 2.226-2.401 1.401 0 2.027.95 2.027 2.4v6.9h3.597v-6.95c0-1.425.8-2.35 2.226-2.35v.001zm7.875 3.125c0 1.2.325 2.3.925 3.3.6 1 1.4 1.75 2.425 2.325 1.05.55 2.175.825 3.425.825 1.225 0 2.375-.275 3.425-.85a6.38 6.38 0 0 0 2.475-2.35c.6-1 .9-2.1.9-3.325s-.3-2.325-.9-3.3a6.26 6.26 0 0 0-2.45-2.325c-1.025-.575-2.175-.85-3.4-.85-1.25 0-2.375.3-3.425.85a6.46 6.46 0 0 0-2.475 2.375c-.6 1-.925 2.1-.925 3.325zm4.6-2.325c.6-.6 1.325-.9 2.175-.9.875 0 1.6.3 2.2.9.6.6.875 1.35.875 2.275 0 .925-.275 1.7-.875 2.275-.6.6-1.325.9-2.175.9-.875 0-1.6-.3-2.2-.9-.575-.6-.875-1.35-.875-2.275 0-.925.3-1.675.875-2.275z"
	});
	
	var _ref5 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M134.278 21.373h4.074l-4.499-6.349 4.374-6.073h-3.999l-2.3 3.499-2.224-3.499h-4.099l4.349 6.173-4.474 6.249h4.024l2.399-3.649 2.375 3.649zm5.977-15.172c.449.45.974.675 1.573.675.625 0 1.174-.225 1.624-.675.425-.45.65-.95.65-1.575s-.225-1.175-.65-1.625a2.305 2.305 0 0 0-1.624-.65c-.599 0-1.124.225-1.573.65-.45.45-.65 1-.65 1.625s.2 1.125.65 1.575zm-.225 2.75v12.422h3.647V8.951h-3.647zm9.774 4.8c.075-.476.375-.977.85-1.452.5-.476 1.099-.701 1.849-.701.85 0 1.6.3 2 .751.4.45.6.926.65 1.402h-5.349zm8.923 2.422c.05-.3.075-.724.075-1.299 0-1.849-.575-3.351-1.725-4.5-1.15-1.149-2.624-1.723-4.474-1.723-1.174 0-2.274.274-3.274.849-1.025.599-1.824 1.373-2.424 2.373a6.281 6.281 0 0 0-.9 3.276c0 1.249.325 2.375.925 3.377.624.999 1.449 1.773 2.474 2.298 1.05.549 2.175.824 3.424.824 1.275 0 2.4-.325 3.424-.974a5.109 5.109 0 0 0 2.15-2.699l-2.999-1.026c-.175.5-.55.901-1.05 1.201-.5.301-1.025.476-1.575.476-.8 0-1.449-.226-2.024-.676-.575-.451-.925-1.026-1.025-1.777h8.998zm4.376 5.475c.7 0 1.299-.25 1.799-.75a2.417 2.417 0 0 0 .725-1.75c0-.7-.25-1.3-.725-1.8a2.53 2.53 0 0 0-1.799-.725c-.699 0-1.274.25-1.774.725-.499.5-.749 1.1-.749 1.8 0 .675.25 1.275.749 1.75.5.5 1.075.75 1.774.75z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: 168,
	    height: 24
	  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  className: "social-icon-facebook"
	}, _react2.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h64v64H0z"
	}), _react2.default.createElement("path", {
	  className: "bottom-layer",
	  d: "M52.24 54.448H16.656a2.208 2.208 0 0 1-2.208-2.208V16.656c0-1.22.988-2.208 2.208-2.208H52.24c1.22 0 2.208.988 2.208 2.208V52.24a2.208 2.208 0 0 1-2.208 2.208z",
	  fill: "#444555"
	}), _react2.default.createElement("path", {
	  className: "top-layer",
	  d: "M30.917 49.552H11.76a2.208 2.208 0 0 1-2.208-2.208V11.76c0-1.22.988-2.208 2.208-2.208h35.584c1.22 0 2.208.988 2.208 2.208v35.584a2.209 2.209 0 0 1-2.208 2.208H37.151v-15.49h5.2l.778-6.037h-5.978v-3.854c0-1.748.486-2.939 2.992-2.939l3.197-.001v-5.4c-.553-.073-2.451-.238-4.658-.238-4.609 0-7.765 2.814-7.765 7.98v4.452h-5.212v6.037h5.212v15.49z",
	  fill: "#476cb8"
	}), _react2.default.createElement("path", {
	  className: "letter-f",
	  d: "M30.843 28.025v-4.452c0-5.166 3.156-7.98 7.764-7.98 2.208 0 4.106.165 4.659.238v5.4l-3.197.001c-2.506 0-2.992 1.191-2.992 2.939v3.854h5.978l-.778 6.037h-5.2v15.49h-6.234v-15.49H25.63v-6.037h5.213z",
	  fill: "#fff"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 64 64"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgY2xhc3M9InNvY2lhbC1pY29uLWZhY2Vib29rIj4KICAgIDxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0wIDBoNjR2NjRIMHoiLz4KICAgIDxwYXRoIGNsYXNzPSJib3R0b20tbGF5ZXIiIGQ9Ik01Mi4yNCA1NC40NDhIMTYuNjU2YTIuMjA4IDIuMjA4IDAgMCAxLTIuMjA4LTIuMjA4VjE2LjY1NmMwLTEuMjIuOTg4LTIuMjA4IDIuMjA4LTIuMjA4SDUyLjI0YzEuMjIgMCAyLjIwOC45ODggMi4yMDggMi4yMDhWNTIuMjRhMi4yMDggMi4yMDggMCAwIDEtMi4yMDggMi4yMDh6IiBmaWxsPSIjNDQ0NTU1Ii8+CiAgICA8cGF0aCBjbGFzcz0idG9wLWxheWVyIiBkPSJNMzAuOTE3IDQ5LjU1MkgxMS43NmEyLjIwOCAyLjIwOCAwIDAgMS0yLjIwOC0yLjIwOFYxMS43NmMwLTEuMjIuOTg4LTIuMjA4IDIuMjA4LTIuMjA4aDM1LjU4NGMxLjIyIDAgMi4yMDguOTg4IDIuMjA4IDIuMjA4djM1LjU4NGEyLjIwOSAyLjIwOSAwIDAgMS0yLjIwOCAyLjIwOEgzNy4xNTF2LTE1LjQ5aDUuMmwuNzc4LTYuMDM3aC01Ljk3OHYtMy44NTRjMC0xLjc0OC40ODYtMi45MzkgMi45OTItMi45MzlsMy4xOTctLjAwMXYtNS40Yy0uNTUzLS4wNzMtMi40NTEtLjIzOC00LjY1OC0uMjM4LTQuNjA5IDAtNy43NjUgMi44MTQtNy43NjUgNy45OHY0LjQ1MmgtNS4yMTJ2Ni4wMzdoNS4yMTJ2MTUuNDl6IiBmaWxsPSIjNDc2Y2I4Ii8+CiAgICA8cGF0aCBjbGFzcz0ibGV0dGVyLWYiIGQ9Ik0zMC44NDMgMjguMDI1di00LjQ1MmMwLTUuMTY2IDMuMTU2LTcuOTggNy43NjQtNy45OCAyLjIwOCAwIDQuMTA2LjE2NSA0LjY1OS4yMzh2NS40bC0zLjE5Ny4wMDFjLTIuNTA2IDAtMi45OTIgMS4xOTEtMi45OTIgMi45Mzl2My44NTRoNS45NzhsLS43NzggNi4wMzdoLTUuMnYxNS40OWgtNi4yMzR2LTE1LjQ5SDI1LjYzdi02LjAzN2g1LjIxM3oiIGZpbGw9IiNmZmYiLz4KICA8L2c+Cjwvc3ZnPgo=";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  className: "social-icon-instagram"
	}, _react2.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h64v64H0z"
	}), _react2.default.createElement("path", {
	  className: "bottom-layer",
	  d: "M34.448 14.448c-5.432 0-6.113.023-8.246.12-2.129.097-3.583.436-4.855.93a9.802 9.802 0 0 0-3.542 2.307 9.802 9.802 0 0 0-2.307 3.542c-.494 1.272-.833 2.726-.93 4.855-.097 2.133-.12 2.814-.12 8.246s.023 6.113.12 8.246c.097 2.129.436 3.583.93 4.855a9.802 9.802 0 0 0 2.307 3.542 9.802 9.802 0 0 0 3.542 2.307c1.272.494 2.726.833 4.855.93 2.133.097 2.814.12 8.246.12s6.113-.023 8.246-.12c2.129-.097 3.583-.436 4.855-.93a9.802 9.802 0 0 0 3.542-2.307 9.802 9.802 0 0 0 2.307-3.542c.494-1.272.833-2.726.93-4.855.097-2.133.12-2.814.12-8.246s-.023-6.113-.12-8.246c-.097-2.129-.436-3.583-.93-4.855a9.802 9.802 0 0 0-2.307-3.542 9.802 9.802 0 0 0-3.542-2.307c-1.272-.494-2.726-.833-4.855-.93-2.133-.097-2.814-.12-8.246-.12zm0 3.604c5.34 0 5.973.02 8.082.116 1.95.089 3.009.415 3.713.689.934.363 1.6.796 2.3 1.496.7.7 1.133 1.366 1.496 2.3.274.704.6 1.763.689 3.713.096 2.109.116 2.742.116 8.082 0 5.34-.02 5.973-.116 8.082-.089 1.95-.415 3.009-.689 3.713-.363.934-.796 1.6-1.496 2.3-.7.7-1.366 1.133-2.3 1.496-.704.274-1.763.6-3.713.689-2.109.096-2.741.116-8.082.116-5.341 0-5.973-.02-8.082-.116-1.95-.089-3.009-.415-3.713-.689-.934-.363-1.6-.796-2.3-1.496-.7-.7-1.133-1.366-1.496-2.3-.274-.704-.6-1.763-.689-3.713-.096-2.109-.116-2.742-.116-8.082 0-5.34.02-5.973.116-8.082.089-1.95.415-3.009.689-3.713.363-.934.796-1.6 1.496-2.3.7-.7 1.366-1.133 2.3-1.496.704-.274 1.763-.6 3.713-.689 2.109-.096 2.742-.116 8.082-.116zm0 6.126c-5.672 0-10.27 4.598-10.27 10.27s4.598 10.27 10.27 10.27 10.27-4.598 10.27-10.27-4.598-10.27-10.27-10.27zm0 16.937a6.667 6.667 0 1 1 0-13.334 6.667 6.667 0 0 1 0 13.334zm13.076-17.343a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0z",
	  fill: "#444555"
	}), _react2.default.createElement("path", {
	  className: "top-layer",
	  d: "M29.552 9.552c-5.432 0-6.113.023-8.246.12-2.129.097-3.583.436-4.855.93a9.802 9.802 0 0 0-3.542 2.307 9.802 9.802 0 0 0-2.307 3.542c-.494 1.272-.833 2.726-.93 4.855-.097 2.133-.12 2.814-.12 8.246s.023 6.113.12 8.246c.097 2.129.436 3.583.93 4.855a9.802 9.802 0 0 0 2.307 3.542 9.802 9.802 0 0 0 3.542 2.307c1.272.494 2.726.833 4.855.93 2.133.097 2.814.12 8.246.12s6.113-.023 8.246-.12c2.129-.097 3.583-.436 4.855-.93a9.802 9.802 0 0 0 3.542-2.307 9.802 9.802 0 0 0 2.307-3.542c.494-1.272.833-2.726.93-4.855.097-2.133.12-2.814.12-8.246s-.023-6.113-.12-8.246c-.097-2.129-.436-3.583-.93-4.855a9.802 9.802 0 0 0-2.307-3.542 9.802 9.802 0 0 0-3.542-2.307c-1.272-.494-2.726-.833-4.855-.93-2.133-.097-2.814-.12-8.246-.12zm0 3.604c5.34 0 5.973.02 8.082.116 1.95.089 3.009.415 3.713.689.934.363 1.6.796 2.3 1.496.7.7 1.133 1.366 1.496 2.3.274.704.6 1.763.689 3.713.096 2.109.116 2.742.116 8.082 0 5.34-.02 5.973-.116 8.082-.089 1.95-.415 3.009-.689 3.713-.363.934-.796 1.6-1.496 2.3-.7.7-1.366 1.133-2.3 1.496-.704.274-1.763.6-3.713.689-2.109.096-2.741.116-8.082.116-5.341 0-5.973-.02-8.082-.116-1.95-.089-3.009-.415-3.713-.689-.934-.363-1.6-.796-2.3-1.496-.7-.7-1.133-1.366-1.496-2.3-.274-.704-.6-1.763-.689-3.713-.096-2.109-.116-2.742-.116-8.082 0-5.34.02-5.973.116-8.082.089-1.95.415-3.009.689-3.713.363-.934.796-1.6 1.496-2.3.7-.7 1.366-1.133 2.3-1.496.704-.274 1.763-.6 3.713-.689 2.109-.096 2.742-.116 8.082-.116zm0 6.126c-5.672 0-10.27 4.598-10.27 10.27s4.598 10.27 10.27 10.27 10.27-4.598 10.27-10.27-4.598-10.27-10.27-10.27zm0 16.937a6.667 6.667 0 1 1 0-13.334 6.667 6.667 0 0 1 0 13.334zm13.076-17.343a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0z",
	  fill: "#e1306c"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 64 64"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  className: "social-icon-twitter"
	}, _react2.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h64v64H0z"
	}), _react2.default.createElement("path", {
	  className: "bottom-layer",
	  d: "M58.448 19.183a19.224 19.224 0 0 1-5.655 1.589 10.076 10.076 0 0 0 4.331-5.584 19.417 19.417 0 0 1-6.258 2.447c-1.791-1.962-4.352-3.187-7.187-3.187-5.435 0-9.844 4.521-9.844 10.098 0 .791.085 1.56.254 2.299-8.185-.422-15.44-4.437-20.3-10.554a10.283 10.283 0 0 0-1.332 5.082c0 3.502 1.738 6.593 4.381 8.405a9.67 9.67 0 0 1-4.463-1.26v.124c0 4.894 3.395 8.977 7.903 9.901a9.39 9.39 0 0 1-2.595.356 9.601 9.601 0 0 1-1.854-.179c1.254 4.01 4.888 6.931 9.199 7.009-3.37 2.71-7.618 4.325-12.23 4.325a19.8 19.8 0 0 1-2.35-.139c4.359 2.86 9.537 4.533 15.096 4.533 18.115 0 28.019-15.385 28.019-28.73 0-.439-.009-.878-.026-1.308a20.206 20.206 0 0 0 4.911-5.227",
	  fill: "#444555"
	}), _react2.default.createElement("path", {
	  className: "top-layer",
	  d: "M53.552 14.287a19.224 19.224 0 0 1-5.655 1.589 10.076 10.076 0 0 0 4.331-5.584 19.417 19.417 0 0 1-6.258 2.447c-1.791-1.962-4.352-3.187-7.187-3.187-5.435 0-9.844 4.521-9.844 10.098 0 .791.085 1.56.254 2.299-8.185-.422-15.44-4.437-20.3-10.554a10.283 10.283 0 0 0-1.332 5.082c0 3.502 1.738 6.593 4.381 8.405a9.67 9.67 0 0 1-4.463-1.26v.124c0 4.894 3.395 8.977 7.903 9.901a9.39 9.39 0 0 1-2.595.356 9.601 9.601 0 0 1-1.854-.179c1.254 4.01 4.888 6.931 9.199 7.009-3.37 2.71-7.618 4.325-12.23 4.325a19.8 19.8 0 0 1-2.35-.139c4.359 2.86 9.537 4.533 15.096 4.533 18.115 0 28.019-15.385 28.019-28.73 0-.439-.009-.878-.026-1.308a20.206 20.206 0 0 0 4.911-5.227",
	  fill: "#1da1f2"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 64 64"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(413);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(653);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),

/***/ 430:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(412)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ }),

/***/ 653:
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),

/***/ 654:
/***/ (function(module, exports) {

	(function(root) {
	  var isOn = false;
	  var scrollbarSize;
	  var scrollTop;
	
	  function getScrollbarSize() {
	    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;
	
	    var doc = document.documentElement;
	    var dummyScroller = document.createElement('div');
	    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
	    doc.appendChild(dummyScroller);
	    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
	    doc.removeChild(dummyScroller);
	    return scrollbarSize;
	  }
	
	  function hasScrollbar() {
	    return document.documentElement.scrollHeight > window.innerHeight;
	  }
	
	  function on(options) {
	    if (typeof document === 'undefined' || isOn) return;
	    var doc = document.documentElement;
	    scrollTop = window.pageYOffset;
	    if (hasScrollbar()) {
	      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
	    } else {
	      doc.style.width = '100%';
	    }
	    doc.style.position = 'fixed';
	    doc.style.top = -scrollTop + 'px';
	    doc.style.overflow = 'hidden';
	    isOn = true;
	  }
	
	  function off() {
	    if (typeof document === 'undefined' || !isOn) return;
	    var doc = document.documentElement;
	    doc.style.width = '';
	    doc.style.position = '';
	    doc.style.top = '';
	    doc.style.overflow = '';
	    window.scroll(0, scrollTop);
	    isOn = false;
	  }
	
	  function toggle() {
	    if (isOn) {
	      off();
	      return;
	    }
	    on();
	  }
	
	  var noScroll = {
	    on: on,
	    off: off,
	    toggle: toggle,
	  };
	
	  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = noScroll;
	  } else {
	    root.noScroll = noScroll;
	  }
	})(this);


/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(655)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowequal = __webpack_require__(271);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _raf = __webpack_require__(658);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldUpdate2 = __webpack_require__(661);
	
	var _shouldUpdate3 = _interopRequireDefault(_shouldUpdate2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-unresolved
	
	
	var noop = function noop() {};
	
	var Headroom = function (_Component) {
	  _inherits(Headroom, _Component);
	
	  function Headroom(props) {
	    _classCallCheck(this, Headroom);
	
	    // Class variables.
	    var _this = _possibleConstructorReturn(this, (Headroom.__proto__ || Object.getPrototypeOf(Headroom)).call(this, props));
	
	    _this.setRef = function (ref) {
	      return _this.inner = ref;
	    };
	
	    _this.setHeightOffset = function () {
	      _this.setState({
	        height: _this.inner.offsetHeight
	      });
	      _this.resizeTicking = false;
	    };
	
	    _this.getScrollY = function () {
	      if (_this.props.parent().pageYOffset !== void 0) {
	        return _this.props.parent().pageYOffset;
	      } else if (_this.props.parent().scrollTop !== void 0) {
	        return _this.props.parent().scrollTop;
	      } else {
	        return (document.documentElement || document.body.parentNode || document.body).scrollTop;
	      }
	    };
	
	    _this.getViewportHeight = function () {
	      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	    };
	
	    _this.getDocumentHeight = function () {
	      var body = document.body;
	      var documentElement = document.documentElement;
	
	      return Math.max(body.scrollHeight, documentElement.scrollHeight, body.offsetHeight, documentElement.offsetHeight, body.clientHeight, documentElement.clientHeight);
	    };
	
	    _this.getElementPhysicalHeight = function (elm) {
	      return Math.max(elm.offsetHeight, elm.clientHeight);
	    };
	
	    _this.getElementHeight = function (elm) {
	      return Math.max(elm.scrollHeight, elm.offsetHeight, elm.clientHeight);
	    };
	
	    _this.getScrollerPhysicalHeight = function () {
	      var parent = _this.props.parent();
	
	      return parent === window || parent === document.body ? _this.getViewportHeight() : _this.getElementPhysicalHeight(parent);
	    };
	
	    _this.getScrollerHeight = function () {
	      var parent = _this.props.parent();
	
	      return parent === window || parent === document.body ? _this.getDocumentHeight() : _this.getElementHeight(parent);
	    };
	
	    _this.isOutOfBound = function (currentScrollY) {
	      var pastTop = currentScrollY < 0;
	
	      var scrollerPhysicalHeight = _this.getScrollerPhysicalHeight();
	      var scrollerHeight = _this.getScrollerHeight();
	
	      var pastBottom = currentScrollY + scrollerPhysicalHeight > scrollerHeight;
	
	      return pastTop || pastBottom;
	    };
	
	    _this.handleScroll = function () {
	      if (!_this.scrollTicking) {
	        _this.scrollTicking = true;
	        (0, _raf2.default)(_this.update);
	      }
	    };
	
	    _this.handleResize = function () {
	      if (!_this.resizeTicking) {
	        _this.resizeTicking = true;
	        (0, _raf2.default)(_this.setHeightOffset);
	      }
	    };
	
	    _this.unpin = function () {
	      _this.props.onUnpin();
	
	      _this.setState({
	        translateY: '-100%',
	        className: 'headroom headroom--unpinned'
	      }, function () {
	        setTimeout(function () {
	          _this.setState({ state: 'unpinned' });
	        }, 0);
	      });
	    };
	
	    _this.pin = function () {
	      _this.props.onPin();
	
	      _this.setState({
	        translateY: 0,
	        className: 'headroom headroom--pinned',
	        state: 'pinned'
	      });
	    };
	
	    _this.unfix = function () {
	      _this.props.onUnfix();
	
	      _this.setState({
	        translateY: 0,
	        className: 'headroom headroom--unfixed',
	        state: 'unfixed'
	      });
	    };
	
	    _this.update = function () {
	      _this.currentScrollY = _this.getScrollY();
	
	      if (!_this.isOutOfBound(_this.currentScrollY)) {
	        var _shouldUpdate = (0, _shouldUpdate3.default)(_this.lastKnownScrollY, _this.currentScrollY, _this.props, _this.state),
	            action = _shouldUpdate.action;
	
	        if (action === 'pin') {
	          _this.pin();
	        } else if (action === 'unpin') {
	          _this.unpin();
	        } else if (action === 'unfix') {
	          _this.unfix();
	        }
	      }
	
	      _this.lastKnownScrollY = _this.currentScrollY;
	      _this.scrollTicking = false;
	    };
	
	    _this.currentScrollY = 0;
	    _this.lastKnownScrollY = 0;
	    _this.scrollTicking = false;
	    _this.resizeTicking = false;
	    _this.state = {
	      state: 'unfixed',
	      translateY: 0,
	      className: 'headroom headroom--unfixed'
	    };
	    return _this;
	  }
	
	  _createClass(Headroom, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setHeightOffset();
	      if (!this.props.disable) {
	        this.props.parent().addEventListener('scroll', this.handleScroll);
	
	        if (this.props.calcHeightOnResize) {
	          this.props.parent().addEventListener('resize', this.handleResize);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disable && !this.props.disable) {
	        this.unfix();
	        this.props.parent().removeEventListener('scroll', this.handleScroll);
	        this.props.parent().removeEventListener('resize', this.handleResize);
	      } else if (!nextProps.disable && this.props.disable) {
	        this.props.parent().addEventListener('scroll', this.handleScroll);
	
	        if (this.props.calcHeightOnResize) {
	          this.props.parent().addEventListener('resize', this.handleResize);
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // If children have changed, remeasure height.
	      if (prevProps.children !== this.props.children) {
	        this.setHeightOffset();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.parent().removeEventListener('scroll', this.handleScroll);
	      window.removeEventListener('scroll', this.handleScroll);
	      this.props.parent().removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          userClassName = _props.className,
	          divProps = _objectWithoutProperties(_props, ['className']);
	
	      delete divProps.onUnpin;
	      delete divProps.onPin;
	      delete divProps.onUnfix;
	      delete divProps.disableInlineStyles;
	      delete divProps.disable;
	      delete divProps.parent;
	      delete divProps.children;
	      delete divProps.upTolerance;
	      delete divProps.downTolerance;
	      delete divProps.pinStart;
	      delete divProps.calcHeightOnResize;
	
	      var style = divProps.style,
	          wrapperStyle = divProps.wrapperStyle,
	          rest = _objectWithoutProperties(divProps, ['style', 'wrapperStyle']);
	
	      var innerStyle = {
	        position: this.props.disable || this.state.state === 'unfixed' ? 'relative' : 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        zIndex: 1,
	        WebkitTransform: 'translateY(' + this.state.translateY + ')',
	        MsTransform: 'translateY(' + this.state.translateY + ')',
	        transform: 'translateY(' + this.state.translateY + ')'
	      };
	
	      var className = this.state.className;
	
	      // Don't add css transitions until after we've done the initial
	      // negative transform when transitioning from 'unfixed' to 'unpinned'.
	      // If we don't do this, the header will flash into view temporarily
	      // while it transitions from 0 — -100%.
	      if (this.state.state !== 'unfixed') {
	        innerStyle = _extends({}, innerStyle, {
	          WebkitTransition: 'all .2s ease-in-out',
	          MozTransition: 'all .2s ease-in-out',
	          OTransition: 'all .2s ease-in-out',
	          transition: 'all .2s ease-in-out'
	        });
	        className += ' headroom--scrolled';
	      }
	
	      if (!this.props.disableInlineStyles) {
	        innerStyle = _extends({}, innerStyle, style);
	      } else {
	        innerStyle = style;
	      }
	
	      var wrapperStyles = _extends({}, wrapperStyle, {
	        height: this.state.height ? this.state.height : null
	      });
	
	      var wrapperClassName = userClassName ? userClassName + ' headroom-wrapper' : 'headroom-wrapper';
	
	      return _react2.default.createElement(
	        'div',
	        { style: wrapperStyles, className: wrapperClassName },
	        _react2.default.createElement(
	          'div',
	          _extends({
	            ref: this.setRef
	          }, rest, {
	            style: innerStyle,
	            className: className
	          }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Headroom;
	}(_react.Component);
	
	Headroom.propTypes = {
	  className: _propTypes2.default.string,
	  parent: _propTypes2.default.func,
	  children: _propTypes2.default.any.isRequired,
	  disableInlineStyles: _propTypes2.default.bool,
	  disable: _propTypes2.default.bool,
	  upTolerance: _propTypes2.default.number,
	  downTolerance: _propTypes2.default.number,
	  onPin: _propTypes2.default.func,
	  onUnpin: _propTypes2.default.func,
	  onUnfix: _propTypes2.default.func,
	  wrapperStyle: _propTypes2.default.object,
	  pinStart: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  calcHeightOnResize: _propTypes2.default.bool
	};
	Headroom.defaultProps = {
	  parent: function parent() {
	    return window;
	  },
	  disableInlineStyles: false,
	  disable: false,
	  upTolerance: 5,
	  downTolerance: 0,
	  onPin: noop,
	  onUnpin: noop,
	  onUnfix: noop,
	  wrapperStyle: {},
	  pinStart: 0,
	  calcHeightOnResize: true
	};
	exports.default = Headroom;

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var lastKnownScrollY = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
	  var currentScrollY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
	  var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	  var state = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
	
	  var scrollDirection = currentScrollY >= lastKnownScrollY ? 'down' : 'up';
	  var distanceScrolled = Math.abs(currentScrollY - lastKnownScrollY);
	
	  // We're disabled
	  if (props.disable) {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're at the top and not fixed yet.
	  } else if (currentScrollY <= props.pinStart && state.state !== 'unfixed') {
	    return {
	      action: 'unfix',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're unfixed and headed down. Carry on.
	  } else if (currentScrollY <= state.height && scrollDirection === 'down' && state.state === 'unfixed') {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're past the header and scrolling down.
	    // We transition to "unpinned" if necessary.
	  } else if (scrollDirection === 'down' && ['pinned', 'unfixed'].indexOf(state.state) >= 0 && currentScrollY > state.height + props.pinStart && distanceScrolled > props.downTolerance) {
	    return {
	      action: 'unpin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're scrolling up, we transition to "pinned"
	  } else if (scrollDirection === 'up' && distanceScrolled > props.upTolerance && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
	    return {
	      action: 'pin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're scrolling up, and inside the header.
	    // We transition to pin regardless of upTolerance
	  } else if (scrollDirection === 'up' && currentScrollY <= state.height && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
	    return {
	      action: 'pin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	  } else {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	  }
	};

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(14);
	var sprite = __webpack_require__(15);
	var symbol = new SpriteSymbol({
	  "id": "shape-twitter-logo",
	  "use": "shape-twitter-logo-usage",
	  "viewBox": "0 0 48 40",
	  "content": "<symbol viewBox=\"0 0 48 40\" id=\"shape-twitter-logo\"><title>Twitter</title><path d=\"M48 4.735a19.235 19.235 0 0 1-5.655 1.59A10.076 10.076 0 0 0 46.675.74a19.395 19.395 0 0 1-6.257 2.447C38.627 1.225 36.066 0 33.231 0c-5.435 0-9.844 4.521-9.844 10.098 0 .791.085 1.56.254 2.3C15.456 11.974 8.2 7.96 3.34 1.842a10.281 10.281 0 0 0-1.33 5.083c0 3.502 1.738 6.593 4.38 8.405a9.668 9.668 0 0 1-4.462-1.26v.124c0 4.894 3.395 8.977 7.903 9.901a9.39 9.39 0 0 1-2.595.356 9.523 9.523 0 0 1-1.854-.18c1.254 4.01 4.888 6.932 9.199 7.01-3.37 2.71-7.618 4.325-12.23 4.325-.795 0-1.58-.047-2.35-.139C4.359 38.327 9.537 40 15.096 40c18.115 0 28.019-15.385 28.019-28.73 0-.439-.009-.878-.026-1.308A20.211 20.211 0 0 0 48 4.735\" /></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("to-querystring",[],e):"object"==typeof exports?exports["to-querystring"]=e():t["to-querystring"]=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=0)}([function(t,e,n){"use strict";function o(t,e,n){if("object"===(void 0===e?"undefined":i(e))){return""+u(e,""+n+(""+t+(n&&"]")+"["))}return n&&n.length?""+n+t+"]="+encodeURIComponent(e):t+"="+encodeURIComponent(e)}function r(t,e,n){return e.map(function(e){return o(t,e,n)}).join("&")}function u(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return Object.keys(t).filter(function(e){return void 0!==t[e]}).map(function(n){return t[n]&&Array.isArray(t[n])?r(n,t[n],e):o(n,t[n],e)}).join("&").replace(/%20/g,"+")}Object.defineProperty(e,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e.default=u}])});

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * EventEmitter v5.2.4 - git.io/ee
	 * Unlicense - http://unlicense.org/
	 * Oliver Caldwell - http://oli.me.uk/
	 * @preserve
	 */
	
	;(function (exports) {
	    'use strict';
	
	    /**
	     * Class for managing events.
	     * Can be extended to provide event functionality in other classes.
	     *
	     * @class EventEmitter Manages event registering and emitting.
	     */
	    function EventEmitter() {}
	
	    // Shortcuts to improve speed and size
	    var proto = EventEmitter.prototype;
	    var originalGlobalValue = exports.EventEmitter;
	
	    /**
	     * Finds the index of the listener for the event in its storage array.
	     *
	     * @param {Function[]} listeners Array of listeners to search through.
	     * @param {Function} listener Method to look for.
	     * @return {Number} Index of the specified listener, -1 if not found
	     * @api private
	     */
	    function indexOfListener(listeners, listener) {
	        var i = listeners.length;
	        while (i--) {
	            if (listeners[i].listener === listener) {
	                return i;
	            }
	        }
	
	        return -1;
	    }
	
	    /**
	     * Alias a method while keeping the context correct, to allow for overwriting of target method.
	     *
	     * @param {String} name The name of the target method.
	     * @return {Function} The aliased method
	     * @api private
	     */
	    function alias(name) {
	        return function aliasClosure() {
	            return this[name].apply(this, arguments);
	        };
	    }
	
	    /**
	     * Returns the listener array for the specified event.
	     * Will initialise the event object and listener arrays if required.
	     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
	     * Each property in the object response is an array of listener functions.
	     *
	     * @param {String|RegExp} evt Name of the event to return the listeners from.
	     * @return {Function[]|Object} All listener functions for the event.
	     */
	    proto.getListeners = function getListeners(evt) {
	        var events = this._getEvents();
	        var response;
	        var key;
	
	        // Return a concatenated array of all matching events if
	        // the selector is a regular expression.
	        if (evt instanceof RegExp) {
	            response = {};
	            for (key in events) {
	                if (events.hasOwnProperty(key) && evt.test(key)) {
	                    response[key] = events[key];
	                }
	            }
	        }
	        else {
	            response = events[evt] || (events[evt] = []);
	        }
	
	        return response;
	    };
	
	    /**
	     * Takes a list of listener objects and flattens it into a list of listener functions.
	     *
	     * @param {Object[]} listeners Raw listener objects.
	     * @return {Function[]} Just the listener functions.
	     */
	    proto.flattenListeners = function flattenListeners(listeners) {
	        var flatListeners = [];
	        var i;
	
	        for (i = 0; i < listeners.length; i += 1) {
	            flatListeners.push(listeners[i].listener);
	        }
	
	        return flatListeners;
	    };
	
	    /**
	     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
	     *
	     * @param {String|RegExp} evt Name of the event to return the listeners from.
	     * @return {Object} All listener functions for an event in an object.
	     */
	    proto.getListenersAsObject = function getListenersAsObject(evt) {
	        var listeners = this.getListeners(evt);
	        var response;
	
	        if (listeners instanceof Array) {
	            response = {};
	            response[evt] = listeners;
	        }
	
	        return response || listeners;
	    };
	
	    function isValidListener (listener) {
	        if (typeof listener === 'function' || listener instanceof RegExp) {
	            return true
	        } else if (listener && typeof listener === 'object') {
	            return isValidListener(listener.listener)
	        } else {
	            return false
	        }
	    }
	
	    /**
	     * Adds a listener function to the specified event.
	     * The listener will not be added if it is a duplicate.
	     * If the listener returns true then it will be removed after it is called.
	     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to attach the listener to.
	     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addListener = function addListener(evt, listener) {
	        if (!isValidListener(listener)) {
	            throw new TypeError('listener must be a function');
	        }
	
	        var listeners = this.getListenersAsObject(evt);
	        var listenerIsWrapped = typeof listener === 'object';
	        var key;
	
	        for (key in listeners) {
	            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
	                listeners[key].push(listenerIsWrapped ? listener : {
	                    listener: listener,
	                    once: false
	                });
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of addListener
	     */
	    proto.on = alias('addListener');
	
	    /**
	     * Semi-alias of addListener. It will add a listener that will be
	     * automatically removed after its first execution.
	     *
	     * @param {String|RegExp} evt Name of the event to attach the listener to.
	     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addOnceListener = function addOnceListener(evt, listener) {
	        return this.addListener(evt, {
	            listener: listener,
	            once: true
	        });
	    };
	
	    /**
	     * Alias of addOnceListener.
	     */
	    proto.once = alias('addOnceListener');
	
	    /**
	     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
	     * You need to tell it what event names should be matched by a regex.
	     *
	     * @param {String} evt Name of the event to create.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.defineEvent = function defineEvent(evt) {
	        this.getListeners(evt);
	        return this;
	    };
	
	    /**
	     * Uses defineEvent to define multiple events.
	     *
	     * @param {String[]} evts An array of event names to define.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.defineEvents = function defineEvents(evts) {
	        for (var i = 0; i < evts.length; i += 1) {
	            this.defineEvent(evts[i]);
	        }
	        return this;
	    };
	
	    /**
	     * Removes a listener function from the specified event.
	     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to remove the listener from.
	     * @param {Function} listener Method to remove from the event.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeListener = function removeListener(evt, listener) {
	        var listeners = this.getListenersAsObject(evt);
	        var index;
	        var key;
	
	        for (key in listeners) {
	            if (listeners.hasOwnProperty(key)) {
	                index = indexOfListener(listeners[key], listener);
	
	                if (index !== -1) {
	                    listeners[key].splice(index, 1);
	                }
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of removeListener
	     */
	    proto.off = alias('removeListener');
	
	    /**
	     * Adds listeners in bulk using the manipulateListeners method.
	     * If you pass an object as the first argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
	     * You can also pass it a regular expression to add the array of listeners to all events that match it.
	     * Yeah, this function does quite a bit. That's probably a bad thing.
	     *
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to add.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addListeners = function addListeners(evt, listeners) {
	        // Pass through to manipulateListeners
	        return this.manipulateListeners(false, evt, listeners);
	    };
	
	    /**
	     * Removes listeners in bulk using the manipulateListeners method.
	     * If you pass an object as the first argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
	     * You can also pass it an event name and an array of listeners to be removed.
	     * You can also pass it a regular expression to remove the listeners from all events that match it.
	     *
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to remove.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeListeners = function removeListeners(evt, listeners) {
	        // Pass through to manipulateListeners
	        return this.manipulateListeners(true, evt, listeners);
	    };
	
	    /**
	     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
	     * The first argument will determine if the listeners are removed (true) or added (false).
	     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
	     * You can also pass it an event name and an array of listeners to be added/removed.
	     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
	     *
	     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
	        var i;
	        var value;
	        var single = remove ? this.removeListener : this.addListener;
	        var multiple = remove ? this.removeListeners : this.addListeners;
	
	        // If evt is an object then pass each of its properties to this method
	        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
	            for (i in evt) {
	                if (evt.hasOwnProperty(i) && (value = evt[i])) {
	                    // Pass the single listener straight through to the singular method
	                    if (typeof value === 'function') {
	                        single.call(this, i, value);
	                    }
	                    else {
	                        // Otherwise pass back to the multiple function
	                        multiple.call(this, i, value);
	                    }
	                }
	            }
	        }
	        else {
	            // So evt must be a string
	            // And listeners must be an array of listeners
	            // Loop over it and pass each one to the multiple method
	            i = listeners.length;
	            while (i--) {
	                single.call(this, evt, listeners[i]);
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Removes all listeners from a specified event.
	     * If you do not specify an event then all listeners will be removed.
	     * That means every event will be emptied.
	     * You can also pass a regex to remove all events that match it.
	     *
	     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeEvent = function removeEvent(evt) {
	        var type = typeof evt;
	        var events = this._getEvents();
	        var key;
	
	        // Remove different things depending on the state of evt
	        if (type === 'string') {
	            // Remove all listeners for the specified event
	            delete events[evt];
	        }
	        else if (evt instanceof RegExp) {
	            // Remove all events matching the regex.
	            for (key in events) {
	                if (events.hasOwnProperty(key) && evt.test(key)) {
	                    delete events[key];
	                }
	            }
	        }
	        else {
	            // Remove all listeners in all events
	            delete this._events;
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of removeEvent.
	     *
	     * Added to mirror the node API.
	     */
	    proto.removeAllListeners = alias('removeEvent');
	
	    /**
	     * Emits an event of your choice.
	     * When emitted, every listener attached to that event will be executed.
	     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
	     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
	     * So they will not arrive within the array on the other side, they will be separate.
	     * You can also pass a regular expression to emit to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
	     * @param {Array} [args] Optional array of arguments to be passed to each listener.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.emitEvent = function emitEvent(evt, args) {
	        var listenersMap = this.getListenersAsObject(evt);
	        var listeners;
	        var listener;
	        var i;
	        var key;
	        var response;
	
	        for (key in listenersMap) {
	            if (listenersMap.hasOwnProperty(key)) {
	                listeners = listenersMap[key].slice(0);
	
	                for (i = 0; i < listeners.length; i++) {
	                    // If the listener returns true then it shall be removed from the event
	                    // The function is executed either with a basic call or an apply if there is an args array
	                    listener = listeners[i];
	
	                    if (listener.once === true) {
	                        this.removeListener(evt, listener.listener);
	                    }
	
	                    response = listener.listener.apply(this, args || []);
	
	                    if (response === this._getOnceReturnValue()) {
	                        this.removeListener(evt, listener.listener);
	                    }
	                }
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of emitEvent
	     */
	    proto.trigger = alias('emitEvent');
	
	    /**
	     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
	     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
	     * @param {...*} Optional additional arguments to be passed to each listener.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.emit = function emit(evt) {
	        var args = Array.prototype.slice.call(arguments, 1);
	        return this.emitEvent(evt, args);
	    };
	
	    /**
	     * Sets the current value to check against when executing listeners. If a
	     * listeners return value matches the one set here then it will be removed
	     * after execution. This value defaults to true.
	     *
	     * @param {*} value The new value to check for when executing listeners.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.setOnceReturnValue = function setOnceReturnValue(value) {
	        this._onceReturnValue = value;
	        return this;
	    };
	
	    /**
	     * Fetches the current value to check against when executing listeners. If
	     * the listeners return value matches this one then it should be removed
	     * automatically. It will return true by default.
	     *
	     * @return {*|Boolean} The current value to check for or the default, true.
	     * @api private
	     */
	    proto._getOnceReturnValue = function _getOnceReturnValue() {
	        if (this.hasOwnProperty('_onceReturnValue')) {
	            return this._onceReturnValue;
	        }
	        else {
	            return true;
	        }
	    };
	
	    /**
	     * Fetches the events object and creates one if required.
	     *
	     * @return {Object} The events storage object.
	     * @api private
	     */
	    proto._getEvents = function _getEvents() {
	        return this._events || (this._events = {});
	    };
	
	    /**
	     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
	     *
	     * @return {Function} Non conflicting EventEmitter class.
	     */
	    EventEmitter.noConflict = function noConflict() {
	        exports.EventEmitter = originalGlobalValue;
	        return EventEmitter;
	    };
	
	    // Expose the class either via AMD, CommonJS or the global object
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return EventEmitter;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === 'object' && module.exports){
	        module.exports = EventEmitter;
	    }
	    else {
	        exports.EventEmitter = EventEmitter;
	    }
	}(this || {}));


/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsonp = __webpack_require__(522);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _toQuerystring = __webpack_require__(698);
	
	var _toQuerystring2 = _interopRequireDefault(_toQuerystring);
	
	var _subscribeForm = __webpack_require__(307);
	
	var _subscribeForm2 = _interopRequireDefault(_subscribeForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable class-methods-use-this */
	
	
	var getAjaxUrl = function getAjaxUrl(url) {
	  return url.replace('/post?', '/post-json?');
	};
	
	var MailChimpSubscribe = function (_Component) {
	  _inherits(MailChimpSubscribe, _Component);
	
	  function MailChimpSubscribe(props) {
	    _classCallCheck(this, MailChimpSubscribe);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = _this.initialState;
	    _this.subscribe = _this.subscribe.bind(_this);
	    return _this;
	  }
	
	  MailChimpSubscribe.prototype.subscribe = function subscribe(data) {
	    var _this2 = this;
	
	    var params = (0, _toQuerystring2.default)(data);
	    var url = getAjaxUrl(this.props.url) + '&' + params;
	
	    this.setState({
	      status: 'sending',
	      message: null
	    }, function () {
	      (0, _jsonp2.default)(url, {
	        param: 'c'
	      }, function (err, responseData) {
	        if (err) {
	          _this2.setState({
	            status: 'error',
	            message: err
	          });
	        } else if (responseData.result !== 'success') {
	          _this2.setState({
	            status: 'error',
	            message: responseData.msg
	          });
	        } else {
	          _this2.setState({
	            status: 'success',
	            message: responseData.msg
	          });
	        }
	      });
	    });
	  };
	
	  MailChimpSubscribe.prototype.render = function render() {
	    return this.props.render({
	      subscribe: this.subscribe,
	      status: this.state.status,
	      message: this.state.message
	    });
	  };
	
	  _createClass(MailChimpSubscribe, [{
	    key: 'initialState',
	    get: function get() {
	      return {
	        status: null,
	        message: null
	      };
	    }
	  }]);
	
	  return MailChimpSubscribe;
	}(_react.Component);
	
	MailChimpSubscribe.propTypes = {
	  url: _propTypes2.default.string.isRequired,
	  render: _propTypes2.default.func
	};
	
	/* eslint-disable */
	MailChimpSubscribe.defaultProps = {
	  render: function render(_ref) {
	    var subscribe = _ref.subscribe,
	        status = _ref.status,
	        message = _ref.message;
	    return _react2.default.createElement(_subscribeForm2.default, {
	      status: status,
	      message: message,
	      onSubmitted: function onSubmitted(formData) {
	        return subscribe(formData);
	      },
	      blob: false
	    });
	  }
	};
	/* eslint-enable */
	
	exports.default = MailChimpSubscribe;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-32fe3b69adbfc84a765b.js